import * as React from "react";

const width = 22;

export const Ad = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 16" width={width} {...props}>
    <path
      {...props}
      d="M21 1V0H1v1H0v14h1v1h20v-1h1V1h-1ZM8 4v1h1v1h1v7H8v-2H5v2H3V6h1V5h1V4h1V3h1v1h1Zm4 8V7h1V6h4V3h2v9h-1v1h-5v-1h-1Z"
    />
    <path {...props} d="M8 7v2H5V7h1V6h1v1h1zM14 8h3v3h-3z" />
  </svg>
);

export const Analytics = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 21" width={width} {...props}>
    <path
      {...props}
      d="M9 10h1v10H9v1H7v-1H6V10h1V9h2v1zM10 4h1v1h-1zM11 5h1v1h-1zM15 7h1v2h-1v1h-2V9h-1V7h1V6h2v1zM15 14h1v6h-1v1h-2v-1h-1v-6h1v-1h2v1zM16 5h1v1h-1zM17 4h1v1h-1zM22 1v2h-1v1h-2V3h-1V1h1V0h2v1h1zM21 10h1v10h-1v1h-2v-1h-1V10h1V9h2v1zM4 6h1v1H4zM3 8h1v2H3v1H1v-1H0V8h1V7h2v1zM3 15h1v5H3v1H1v-1H0v-5h1v-1h2v1zM5 5h1v1H5zM7 3H6V1h1V0h2v1h1v2H9v1H7V3z"
    />
  </svg>
);

export const AngelList = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 22" width={width} {...props}>
    <path
      {...props}
      d="M14 11h1v7h-1zM14 1h1v3h-1zM13 18h1v1h-1zM13 10h1v1h-1zM13 4h1v3h-1zM12 19h1v1h-1zM12 7h1v2h-1zM12 0h2v1h-2zM10 9h3v1h-3zM11 1h1v2h-1zM10 20h2v1h-2zM10 3h1v3h-1zM9 18h1v1H9zM10 6v3H7V8h1V6h2zM12 12v1h-1v1h-1v1H9v3H8v-1H7v1H6v-2h2v-3H7v-1h5zM7 3h1v3H7zM6 21h4v1H6zM6 11h1v1H6zM6 1h1v2H6zM5 15h1v1H5zM7 9v1H6v1H5v-1H3V9h2V7h1v2h1zM4 20h2v1H4zM4 18h2v1H4zM4 14h1v1H4zM4 4h1v3H4zM4 0h2v1H4zM3 19h1v1H3zM3 17h1v1H3zM3 1h1v3H3zM2 18h1v1H2zM2 16h1v1H2zM2 10h1v3H2zM1 17h1v1H1zM1 13h3v1H1zM0 14h1v3H0z"
    />
  </svg>
);

export const Table = props => (
  <svg fill="#ffffff" width={width} {...props} viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 4L9 20M15 4L15 20M3 9H21M3 15H21M6.2 20H17.8C18.9201 20 19.4802 20 19.908 19.782C20.2843 19.5903 20.5903 19.2843 20.782 18.908C21 18.4802 21 17.9201 21 16.8V7.2C21 6.0799 21 5.51984 20.782 5.09202C20.5903 4.71569 20.2843 4.40973 19.908 4.21799C19.4802 4 18.9201 4 17.8 4H6.2C5.07989 4 4.51984 4 4.09202 4.21799C3.71569 4.40973 3.40973 4.71569 3.21799 5.09202C3 5.51984 3 6.07989 3 7.2V16.8C3 17.9201 3 18.4802 3.21799 18.908C3.40973 19.2843 3.71569 19.5903 4.09202 19.782C4.51984 20 5.07989 20 6.2 20Z"
      stroke="#000000"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AngleDown = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 10" width={width} {...props}>
    <path
      {...props}
      d="M1 0h2v1h1v1h1v1h1v1h1v1h2V4h1V3h1V2h1V1h1V0h2v1h1v2h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1H9v1H7V9H6V8H5V7H4V6H3V5H2V4H1V3H0V1h1V0z"
    />
  </svg>
);

export const AngleLeft = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 16" width={width} {...props}>
    <path
      {...props}
      d="M10 1v2H9v1H8v1H7v1H6v1H5v2h1v1h1v1h1v1h1v1h1v2H9v1H7v-1H6v-1H5v-1H4v-1H3v-1H2v-1H1V9H0V7h1V6h1V5h1V4h1V3h1V2h1V1h1V0h2v1h1z"
    />
  </svg>
);

export const AngleRight = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 16" width={width} {...props}>
    <path
      {...props}
      d="M0 15v-2h1v-1h1v-1h1v-1h1V9h1V7H4V6H3V5H2V4H1V3H0V1h1V0h2v1h1v1h1v1h1v1h1v1h1v1h1v1h1v2H9v1H8v1H7v1H6v1H5v1H4v1H3v1H1v-1H0z"
    />
  </svg>
);

export const AngleUp = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 10" width={width} {...props}>
    <path
      {...props}
      d="M15 10h-2V9h-1V8h-1V7h-1V6H9V5H7v1H6v1H5v1H4v1H3v1H1V9H0V7h1V6h1V5h1V4h1V3h1V2h1V1h1V0h2v1h1v1h1v1h1v1h1v1h1v1h1v1h1v2h-1v1z"
    />
  </svg>
);

export const ArrowAltCircleLeft = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M1 14v2h1v2h1v1h1v1h2v1h2v1h6v-1h2v-1h2v-1h1v-1h1v-2h1v-2h1V8h-1V6h-1V4h-1V3h-1V2h-2V1h-2V0H8v1H6v1H4v1H3v1H2v2H1v2H0v6h1Zm1-6h1V6h1V4h2V3h2V2h6v1h2v1h2v2h1v2h1v6h-1v2h-1v2h-2v1h-2v1H8v-1H6v-1H4v-2H3v-2H2V8Z"
    />
    <path {...props} d="M6 12v-2h1V9h1V8h1V7h1V6h1v4h6v2h-6v4h-1v-1H9v-1H8v-1H7v-1H6z" />
  </svg>
);

export const ArrowAltCircleRight = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M21 8V6h-1V4h-1V3h-1V2h-2V1h-2V0H8v1H6v1H4v1H3v1H2v2H1v2H0v6h1v2h1v2h1v1h1v1h2v1h2v1h6v-1h2v-1h2v-1h1v-1h1v-2h1v-2h1V8h-1Zm-1 6h-1v2h-1v2h-2v1h-2v1H8v-1H6v-1H4v-2H3v-2H2V8h1V6h1V4h2V3h2V2h6v1h2v1h2v2h1v2h1v6Z"
    />
    <path {...props} d="M16 10v2h-1v1h-1v1h-1v1h-1v1h-1v-4H5v-2h6V6h1v1h1v1h1v1h1v1h1z" />
  </svg>
);

export const ArrowCircleDown = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M1 15v2h1v1h1v1h1v1h1v1h2v1h8v-1h2v-1h1v-1h1v-1h1v-1h1v-2h1V7h-1V5h-1V4h-1V3h-1V2h-1V1h-2V0H7v1H5v1H4v1H3v1H2v1H1v2H0v8h1Zm9-1V4h2v10h1v-1h1v-1h1v-1h1v-1h1v1h1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-2v-1H9v-1H8v-1H7v-1H6v-1H5v-1H4v-1h1v-1h1v1h1v1h1v1h1v1h1Z"
    />
  </svg>
);

export const ArrowCircleUp = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M21 7V5h-1V4h-1V3h-1V2h-1V1h-2V0H7v1H5v1H4v1H3v1H2v1H1v2H0v8h1v2h1v1h1v1h1v1h1v1h2v1h8v-1h2v-1h1v-1h1v-1h1v-1h1v-2h1V7h-1Zm-9 1v10h-2V8H9v1H8v1H7v1H6v1H5v-1H4v-1h1V9h1V8h1V7h1V6h1V5h1V4h2v1h1v1h1v1h1v1h1v1h1v1h1v1h-1v1h-1v-1h-1v-1h-1V9h-1V8h-1Z"
    />
  </svg>
);

export const ArrowDown = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M12 22h-2v-1H9v-1H8v-1H7v-1H6v-1H5v-1H4v-1H3v-1H2v-1H1v-1H0v-1h1v-1h1V9h1v1h1v1h1v1h1v1h1v1h1v1h1V0h4v15h1v-1h1v-1h1v-1h1v-1h1v-1h1V9h1v1h1v1h1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1z"
    />
  </svg>
);

export const ArrowLeft = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M0 12v-2h1V9h1V8h1V7h1V6h1V5h1V4h1V3h1V2h1V1h1V0h1v1h1v1h1v1h-1v1h-1v1h-1v1H9v1H8v1H7v1h15v4H7v1h1v1h1v1h1v1h1v1h1v1h1v1h-1v1h-1v1h-1v-1H9v-1H8v-1H7v-1H6v-1H5v-1H4v-1H3v-1H2v-1H1v-1H0z"
    />
  </svg>
);

export const ArrowRight = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M22 10v2h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v-1h-1v-1H9v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1H0V9h15V8h-1V7h-1V6h-1V5h-1V4h-1V3H9V2h1V1h1V0h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1z"
    />
  </svg>
);

export const ArrowUp = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M10 0h2v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h-1V9h-1V8h-1V7h-1v15H9V7H8v1H7v1H6v1H5v1H4v1H3v1H2v-1H1v-1H0v-1h1V9h1V8h1V7h1V6h1V5h1V4h1V3h1V2h1V1h1V0z"
    />
  </svg>
);

export const At = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M21 9V7h-1V5h-1V3h-1V2h-2V1h-3V0H9v1H6v1H4v1H3v1H2v2H1v2H0v6h1v2h1v2h1v1h1v1h2v1h3v1h4v-1h3v-2h-3v1H9v-1H6v-1H5v-1H4v-2H3v-2H2V9h1V7h1V5h1V4h1V3h3V2h4v1h3v1h1v1h1v2h1v2h1v4h-1v1h-2V9h-1V7h-1V6h-2V5H9v1H7v1H6v2H5v4h1v2h1v1h2v1h4v-1h2v-1h1v1h4v-1h1v-2h1V9h-1Zm-6 4h-1v1h-1v1H9v-1H8v-1H7V9h1V8h1V7h4v1h1v1h1v4Z"
    />
  </svg>
);

export const Audio = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width={width} {...props}>
    <path d="M8.66675 2.49976H0.666748V4.49976H8.66675V2.49976Z" />
    <path d="M8.66675 6.49976H0.666748V8.49976H8.66675V6.49976Z" />
    <path d="M4.66675 10.4998H0.666748V12.4998H4.66675V10.4998Z" />
    <path d="M15.3333 1.1665V5.1665H14V5.83317H12.6667V14.4998H12V15.1665H11.3333V15.8332H8V15.1665H6.66667V14.4998H6V12.4998H6.66667V11.8332H8V11.1665H10.6667V3.1665H11.3333V2.49984H12.6667V1.83317H14V1.1665H15.3333Z" />
  </svg>
);

export const BadgeCheck = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M10 0h2v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h-1V9h-1V8h-1V7h-1v15H9V7H8v1H7v1H6v1H5v1H4v1H3v1H2v-1H1v-1H0v-1h1V9h1V8h1V7h1V6h1V5h1V4h1V3h1V2h1V1h1V0z"
    />
  </svg>
);

export const Bars = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 20" width={width} {...props}>
    <path
      {...props}
      d="M21 9h1v2h-1v1H1v-1H0V9h1V8h20v1zM21 17h1v2h-1v1H1v-1H0v-2h1v-1h20v1zM22 1v2h-1v1H1V3H0V1h1V0h20v1h1z"
    />
  </svg>
);

export const Fire = ({width = 12, fill = "#ffffff"}) => (
  <svg viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg" width={width} fill={fill}>
    <path
      fill={fill}
      d="M13.1667 9.16675V7.16675H12.5V6.50008H11.8333V4.50008H11.1667V3.16675H10.5V2.50008H9.83333V1.83341H9.16667V1.16675H7.83333V1.83341H8.5V3.16675H7.83333V4.50008H7.16667V5.16675H6.5V5.83342H5.83333V6.50008H5.16667V7.16675H4.5V9.16675H5.16667V10.5001H4.5V9.83342H3.83333V8.50008H3.16667V9.83342H2.5V11.8334H3.16667V13.1667H3.83333V13.8334H4.5V14.5001H5.16667V15.1667H5.83333V15.8334H11.1667V15.1667H11.8333V14.5001H12.5V13.8334H13.1667V12.5001H13.8333V9.16675H13.1667ZM11.8333 13.8334H11.1667V14.5001H9.83333V15.1667H7.16667V14.5001H6.5V11.8334H7.16667V11.1667H7.83333V10.5001H8.5V9.83342H9.16667V7.83342H8.5V7.16675H7.83333V6.50008H8.5V7.16675H9.83333V8.50008H10.5V11.8334H9.83333V13.1667H10.5V12.5001H11.1667V11.8334H11.8333V13.8334Z"
    />
  </svg>
);

export const BellExclamation = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 22" width={width} {...props}>
    <path
      {...props}
      d="M13 19v2h-1v1H8v-1H7v-2h6zM19 16v-1h-1v-2h-1V7h-1V5h-1V4h-1V3h-2V2h-1V0H9v2H8v1H6v1H5v1H4v2H3v6H2v2H1v1H0v1h1v1h18v-1h1v-1h-1ZM12 5v3h-1v3H9V8H8V5h4Zm-3 8h2v2H9v-2Z"
    />
  </svg>
);

export const Bell = ({fill = "black", ...props}) => (
  <svg width={width} fill={fill} {...props} id="Bell" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <polygon points="15 20 15 22 14 22 14 23 10 23 10 22 9 22 9 20 15 20" />
    <path
      fill={fill}
      d="m21,17v-1h-1v-2h-1v-6h-1v-2h-1v-1h-1v-1h-2v-1h-1V1h-2v2h-1v1h-2v1h-1v1h-1v2h-1v6h-1v2h-1v1h-1v1h1v1h18v-1h1v-1h-1Zm-15-1v-2h1v-6h1v-2h2v-1h4v1h2v2h1v6h1v2h1v1H5v-1h1Z"
    />
  </svg>
);

export const BookHeart = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 22" width={width} {...props}>
    <path
      {...props}
      d="M19 16v-1h1V1h-1V0H2v1H1v1H0v18h1v1h1v1h17v-1h1v-1h-1v-1h-1v-3h1Zm-3 4H4v-1H3v-2h1v-1h12v4Zm0-12h-1v1h-1v1h-1v1h-1v1h-1v1h-1v-1H9v-1H8v-1H7V9H6V8H5V5h1V4h3v1h1v1h1V5h1V4h3v1h1v3Z"
    />
  </svg>
);

export const Bookmark = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 22" width={width} {...props}>
    <path
      {...props}
      d="M16 1v21h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1H9v-1H7v1H6v1H5v1H4v1H3v1H2v1H1v1H0V1h1V0h14v1h1z"
    />
  </svg>
);

export const BoxUsd = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M0 8v13h1v1h20v-1h1V8H0Zm12 11v2h-2v-2H8v-2h4v-1H9v-1H8v-4h2V9h2v2h2v2h-4v1h3v1h1v4h-2ZM10 0v6H0V5h1V3h1V2h1V1h1V0h6zM22 5v1H12V0h6v1h1v1h1v1h1v2h1z"
    />
  </svg>
);

export const Bullhorn = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 20" width={width} {...props}>
    <path
      {...props}
      d="M21 8V7h-1V1h-1V0h-1v1h-1v1h-2v1h-2v1h-2v1H1v1H0v7h1v1h3v5h1v1h2v-1h1v-5h3v1h2v1h2v1h2v1h1v1h1v-1h1v-6h1v-1h1V8h-1Zm-3 7h-2v-1h-2v-1h-2v-1H9V7h3V6h2V5h2V4h2v11Z"
    />
  </svg>
);

export const Calendar = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M5 0h2v1H5zM15 0h2v1h-2zM21 4V3h-3V1h-1v5h-2V1h-1v2H8V1H7v5H5V1H4v2H1v1H0v17h1v1h20v-1h1V4h-1Zm-1 3v3h-3V7h3Zm0 8h-3v-3h3v3Zm0 5h-3v-3h3v3ZM2 17h3v3H2v-3Zm0-5h3v3H2v-3Zm13 3h-3v-3h3v3Zm-5 0H7v-3h3v3Zm-3 2h3v3H7v-3Zm5 0h3v3h-3v-3Zm3-7h-3V7h3v3Zm-5-3v3H7V7h3Zm-5 3H2V7h3v3Z"
    />
  </svg>
);

export const ChartLine = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 16" width={width} {...props}>
    <path
      {...props}
      d="M5 9V7h1V6h1V5h1V4h1v1h1v1h1v1h1v1h1V7h1V6h1V5h1V3h-1V2h-1V1h7v7h-1V7h-1V6h-2v1h-1v1h-1v1h-1v1h-1v1h-1v-1h-1V9h-1V8H9V7H8v1H7v1H5z"
    />
    <path {...props} d="M22 13v3H1v-1H0V0h3v13h19z" />
  </svg>
);

export const ChartNetwork = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 19" width={width} {...props}>
    <path
      {...props}
      d="M6 4H4V3H3V1h1V0h2v1h1v2H6v1zM4 8h1v3H4v1H1v-1H0V8h1V7h3v1zM8 5h1v1H8zM14 12h1v1h-1zM16 5h1v1h-1zM7 4h1v1H7zM6 9h1v1H6z"
    />
    <path
      {...props}
      d="M15 11V8h-1V7h-1V6h-3v1H9v1H8v3h1v1h1v1h3v-1h1v-1h1Zm-5 0V8h3v3h-3ZM15 6h1v1h-1zM15 13h1v1h-1zM20 15h1v3h-1v1h-3v-1h-1v-3h1v-1h3v1zM21 2v2h-1v1h-2V4h-1V2h1V1h2v1h1z"
    />
  </svg>
);

export const CheckCircle = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M21 8V6h-1V4h-1V3h-1V2h-2V1h-2V0H8v1H6v1H4v1H3v1H2v2H1v2H0v6h1v2h1v2h1v1h1v1h2v1h2v1h6v-1h2v-1h2v-1h1v-1h1v-2h1v-2h1V8h-1Zm-4 3h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1H9v-1H8v-1H7v-1H6v-1H5v-2h1v-1h2v1h1v1h2v-1h1v-1h1V9h1V8h1V7h2v1h1v2h-1v1Z"
    />
  </svg>
);

export const CheckLight = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 16" width={width} {...props}>
    <path
      {...props}
      d="M22 0v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1H9v1H8v1H7v1H5v-1H4v-1H3v-1H2v-1H1v-1H0v-1h2v1h1v1h1v1h1v1h2v-1h1v-1h1v-1h1v-1h1V9h1V8h1V7h1V6h1V5h1V4h1V3h1V2h1V1h1V0h2z"
    />
  </svg>
);

export const Check = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 16" width={width} {...props}>
    <path
      {...props}
      d="M22 2v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1H9v1H7v-1H6v-1H5v-1H4v-1H3v-1H2v-1H1V9H0V8h1V7h1V6h1v1h1v1h1v1h1v1h1v1h2v-1h1V9h1V8h1V7h1V6h1V5h1V4h1V3h1V2h1V1h1V0h1v1h1v1h1z"
    />
  </svg>
);

export const ChevronDown = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 13" width={width} {...props}>
    <path
      {...props}
      d="M22 2v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-2v-1H9v-1H8v-1H7V9H6V8H5V7H4V6H3V5H2V4H1V3H0V2h1V1h1V0h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h2V7h1V6h1V5h1V4h1V3h1V2h1V1h1V0h1v1h1v1h1z"
    />
  </svg>
);

export const ChevronUp = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 13" width={width} {...props}>
    <path
      {...props}
      d="M22 10v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h-1V9h-1V8h-1V7h-1V6h-1V5h-2v1H9v1H8v1H7v1H6v1H5v1H4v1H3v1H2v-1H1v-1H0v-1h1V9h1V8h1V7h1V6h1V5h1V4h1V3h1V2h1V1h1V0h2v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1z"
    />
  </svg>
);

export const CirlceNotch = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M22 8v6h-1v2h-1v2h-1v1h-1v1h-2v1h-2v1H8v-1H6v-1H4v-1H3v-1H2v-2H1v-2H0V8h1V6h1V4h1V3h1V2h2V1h2V0h1v1h1v1H9v1H7v1H5v1H4v2H3v2H2v4h1v2h1v2h1v1h2v1h2v1h4v-1h2v-1h2v-1h1v-2h1v-2h1V9h-1V7h-1V5h-1V4h-2V3h-2V2h-1V1h1V0h1v1h2v1h2v1h1v1h1v2h1v2h1z"
    />
  </svg>
);

export const Clock = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M21 8V6h-1V4h-1V3h-1V2h-2V1h-2V0H8v1H6v1H4v1H3v1H2v2H1v2H0v6h1v2h1v2h1v1h1v1h2v1h2v1h6v-1h2v-1h2v-1h1v-1h1v-2h1v-2h1V8h-1Zm-1 6h-1v2h-1v2h-2v1h-2v1H8v-1H6v-1H4v-2H3v-2H2V8h1V6h1V4h2V3h2V2h6v1h2v1h2v2h1v2h1v6Z"
    />
    <path {...props} d="M15 14v1h-1v1h-1v-1h-1v-1h-1v-1h-1V4h2v8h1v1h1v1h1z" />
  </svg>
);

export const CloudDownloadAlt = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 15" {...props}>
    <path
      {...props}
      d="M21 7V6h-2V4h-1V3h-1V2h-3v1h-1V1h-1V0H7v1H6v1H5v1H4v3H1v1H0v5h1v1h1v1h2v1h14v-1h2v-1h1v-1h1V7h-1ZM8 12v-1H7v-1H6V9H5V8h3V4h3v4h3v1h-1v1h-1v1h-1v1h-1v1H9v-1H8Z"
    />
  </svg>
);

export const CloudUpload = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 15" width={width} {...props}>
    <path
      {...props}
      d="M21 7V6h-2V4h-1V3h-1V2h-3v1h-1V1h-1V0H7v1H6v1H5v1H4v3H1v1H0v5h1v1h1v1h2v1h14v-1h2v-1h1v-1h1V7h-1ZM8 9H5V8h1V7h1V6h1V5h1V4h1v1h1v1h1v1h1v1h1v1h-3v4H8V9Z"
    />
  </svg>
);

export const Code = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 18" width={width} {...props}>
    <path
      {...props}
      d="M14 1h1v2h-1v3h-1v3h-1v2h-1v3h-1v3H9v1H8v-1H7v-2h1v-3h1V9h1V7h1V4h1V1h1V0h1v1zM22 8v2h-1v1h-1v1h-1v1h-1v1h-2v-2h1v-1h1v-1h1V8h-1V7h-1V6h-1V4h2v1h1v1h1v1h1v1h1zM6 4v2H5v1H4v1H3v2h1v1h1v1h1v2H4v-1H3v-1H2v-1H1v-1H0V8h1V7h1V6h1V5h1V4h2z"
    />
  </svg>
);

export const Cog = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M18 6h1v2h-1zM18 14h1v2h-1zM14 18h2v1h-2zM6 18h2v1H6zM3 14h1v2H3zM3 6h1v2H3zM6 3h2v1H6zM22 9v4h-2v-1h1v-2h-1V9h2zM19 16h1v2h-1zM19 13h1v1h-1zM19 8h1v1h-1zM19 4h1v2h-1zM18 18h1v1h-1zM18 3h1v1h-1zM16 2h2v1h-2zM16 19h2v1h-2zM14 3h2v1h-2zM14 9h1v4h-1zM13 19h1v1h-1zM13 13h1v1h-1zM13 8h1v1h-1zM13 2h1v1h-1zM13 20v2H9v-2h1v1h2v-1h1zM9 14h4v1H9zM9 7h4v1H9zM13 0v2h-1V1h-2v1H9V0h4zM8 19h1v1H8zM8 13h1v1H8zM8 8h1v1H8zM8 2h1v1H8zM7 9h1v4H7zM4 19h2v1H4zM4 2h2v1H4zM3 18h1v1H3zM3 3h1v1H3zM2 16h1v2H2zM2 13h1v1H2zM2 8h1v1H2zM2 4h1v2H2zM1 12h1v1H0V9h2v1H1v2z"
    />
  </svg>
);

export const CogSolid = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" {...props}>
    <path
      {...props}
      d="M20 9V8h-1V6h1V4h-1V3h-1V2h-2v1h-2V2h-1V0H9v2H8v1H6V2H4v1H3v1H2v2h1v2H2v1H0v4h2v1h1v2H2v2h1v1h1v1h2v-1h2v1h1v2h4v-2h1v-1h2v1h2v-1h1v-1h1v-2h-1v-2h1v-1h2V9h-2ZM9 9V8h4v1h1v4h-1v1H9v-1H8V9h1Z"
    />
  </svg>
);

export const Coins = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 18" width={width} {...props}>
    <path
      {...props}
      d="M19 12h2v1h-2zM22 2v10h-1V9h-2V8h2V5h-2V4h2V2h1zM19 1h2v1h-2zM10 0h9v1h-9zM8 1h2v1H8zM3 13h9v1H3zM1 9v3h2v1H1v3H0V6h1v2h2v1H1zM3 9h9v1H3zM12 16h2v1h-2zM3 17h9v1H3zM1 16h2v1H1zM15 6v3h4v1h-4v3h4v1h-4v2h-1v-3h-2v-1h2V9h-2V8h2V6h-2V5h7v1h-4zM12 4v1H3V4h4V2h1v2h4zM1 5h2v1H1z"
    />
  </svg>
);

export const CommentQuote = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 19" width={width} {...props}>
    <path
      {...props}
      d="M21 6V4h-1V3h-1V2h-2V1h-3V0H8v1H5v1H3v1H2v1H1v2H0v6h1v2h1v2H1v1H0v2h5v-1h1v-1h2v1h6v-1h3v-1h2v-1h1v-1h1v-2h1V6h-1ZM6 13h1v-1h1v-2H6V5h4v8H9v1H6v-1Zm6 0h1v-1h1v-2h-2V5h4v8h-1v1h-3v-1Z"
    />
  </svg>
);

export const Comment = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 19" width={width} {...props}>
    <path
      {...props}
      d="M22 6v6h-1v2h-1v1h-1v1h-2v1h-3v1H8v-1H6v1H5v1H0v-2h1v-1h1v-2H1v-2H0V6h1V4h1V3h1V2h2V1h3V0h6v1h3v1h2v1h1v1h1v2h1z"
    />
  </svg>
);

export const Comments = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M22 13V8h-1V6h-2V5h-2V4h-3V2h-2V1h-2V0H5v1H3v1H1v2H0v5h1v2H0v4h3v-1h1v-1h4v2h2v1h2v1h6v1h1v1h3v-4h-1v-2h1ZM4 11v1H3v1H2v-2h1V9H2V4h1V3h2V2h5v1h2v1h1v5h-1v1h-2v1H4Zm16 2h-1v2h1v2h-1v-1h-1v-1h-6v-1h-2v-2h2v-1h2V9h1V6h2v1h2v1h1v5Z"
    />
  </svg>
);

export const Copy = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 22" width={width} {...props}>
    <path {...props} d="M14 19v2h-1v1H1v-1H0V5h1V4h3v15h10z" />
    <path {...props} d="M20 6v11h-1v1H6v-1H5V1h1V0h8v6h6z" />
    <path {...props} d="M20 4v1h-5V0h1v1h1v1h1v1h1v1h1z" />
  </svg>
);

export const Discourse = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M21 8V6h-1V4h-1V3h-1V2h-2V1h-2V0H8v1H6v1H4v1H3v1H2v2H1v2H0v14h14v-1h2v-1h2v-1h1v-1h1v-2h1v-2h1V8h-1Zm-5-1v1h1v6h-1v1h-1v1h-1v1H9v-1H8v1H6v1H4v-1h1v-2h1v-1H5V8h1V7h1V6h1V5h6v1h1v1h1Z"
    />
  </svg>
);

export const Download = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M18 10v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-2v-1H9v-1H8v-1H7v-1H6v-1H5v-1H4v-1h4V1h1V0h4v1h1v9h4z"
    />
    <path
      {...props}
      d="M21 15v-1h-6v1h-1v1h-1v1h-1v1h-2v-1H9v-1H8v-1H7v-1H1v1H0v6h1v1h20v-1h1v-6h-1Zm-2 4h-1v-1h1v1Zm-3-1h1v1h-1v-1Z"
    />
  </svg>
);

export const DownloadAlt = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path d="M14.6666 13.8333H1.33325V15.8333H14.6666V13.8333Z" fill={props?.fill || "black"} />
    <path
      d="M13.3334 5.83342V7.16675H12.6667V7.83342H12.0001V8.50008H11.3334V9.16675H10.6667V9.83342H10.0001V10.5001H9.33342V11.1667H8.66675V11.8334H7.33342V11.1667H6.66675V10.5001H6.00008V9.83342H5.33341V9.16675H4.66675V8.50008H4.00008V7.83342H3.33341V7.16675H2.66675V5.83342H3.33341V5.16675H4.66675V5.83342H5.33341V6.50008H6.00008V7.16675H6.66675V1.16675H9.33342V7.16675H10.0001V6.50008H10.6667V5.83342H11.3334V5.16675H12.6667V5.83342H13.3334Z"
      fill={props?.fill || "black"}
    />
  </svg>
);

export const Edit = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 19" width={width} {...props}>
    <path
      {...props}
      d="M21 1v3h-1v1h-1V4h-1V3h-1V2h-1V1h1V0h3v1h1zM16 11h1v7h-1v1H1v-1H0V3h1V2h12v1h-1v1H2v13h13v-5h1v-1z"
    />
    <path
      {...props}
      d="M17 5h1v2h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1H6v-4h1v-1h1V9h1V8h1V7h1V6h1V5h1V4h1V3h2v1h1v1z"
    />
  </svg>
);

export const VerticalDots = props => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path {...props} d="M15 3V5H14V6H13V7H11V6H10V5H9V3H10V2H11V1H13V2H14V3H15Z" fill="#555555" />
    <path {...props} d="M14 11H15V13H14V14H13V15H11V14H10V13H9V11H10V10H11V9H13V10H14V11Z" fill="#555555" />
    <path {...props} d="M14 19H15V21H14V22H13V23H11V22H10V21H9V19H10V18H11V17H13V18H14V19Z" fill="#555555" />
  </svg>
);

export const Envelope = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 16" width={width} {...props}>
    <path {...props} d="M20 0v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-2V8H9V7H8V6H7V5H6V4H5V3H4V2H3V1H2V0h18z" />
    <path
      {...props}
      d="M22 1v14h-1v1H1v-1H0V1h2v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h2V9h1V8h1V7h1V6h1V5h1V4h1V3h1V2h1V1h2z"
    />
  </svg>
);

export const ExclamationTriangle = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M21 19v-2h-1v-2h-1v-2h-1v-2h-1V9h-1V7h-1V5h-1V3h-1V1h-1V0h-2v1H9v2H8v2H7v2H6v2H5v2H4v2H3v2H2v2H1v2H0v2h1v1h20v-1h1v-2h-1ZM9 10h4v3h-1v3h-2v-3H9v-3Zm1 7h2v2h-2v-2Z"
    />
  </svg>
);

export const Exclamation = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 22" width={width} {...props}>
    <path {...props} d="M8 17v3H7v1H6v1H2v-1H1v-1H0v-3h1v-1h1v-1h4v1h1v1h1zM2 7H1V0h6v7H6v6H2V7z" />
  </svg>
);

export const Expand = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M8 19v3H1v-1H0v-7h3v5h5zM8 0v3H3v5H0V1h1V0h7zM22 14v7h-1v1h-7v-3h5v-5h3zM22 1v7h-3V3h-5V0h7v1h1z"
    />
  </svg>
);

export const ExternalLinkAlt = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M22 0v8h-2V7h-1V6h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1H9v1H8v1H7v-1H6v-1H5v-1h1v-1h1v-1h1v-1h1v-1h1V9h1V8h1V7h1V6h1V5h1V4h1V3h-1V2h-1V0h8z"
    />
    <path {...props} d="M19 14v7h-1v1H1v-1H0V4h1V3h9v3H3v13h13v-5h3z" />
  </svg>
);

export const ExternalLinkSquare = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M21 1h1v20h-1zM14 7h1v1h-1zM13 8h1v1h-1zM12 9h1v1h-1zM11 10h1v1h-1zM10 11h1v1h-1zM9 12h1v1H9z"
    />
    <path
      {...props}
      d="M17 5v8h-1V7h-1V6H9V5h8zM8 13h1v1H8zM7 14h1v1H7zM6 15h1v1H6zM5 16h1v1H5zM1 21h20v1H1zM1 0h20v1H1zM0 1h1v20H0z"
    />
  </svg>
);

export const ExternalLink = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M22 0v8h-2V7h-1V6h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1H9v1H8v1H7v-1H6v-1H5v-1h1v-1h1v-1h1v-1h1v-1h1V9h1V8h1V7h1V6h1V5h1V4h1V3h-1V2h-1V0h8z"
    />
    <path {...props} d="M19 14v7h-1v1H1v-1H0V4h1V3h9v3H3v13h13v-5h3z" />
  </svg>
);

export const Eye = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 14" width={width} {...props}>
    <path {...props} d="M15 6v2h-1v1h-1v1h-1v1h-2v-1H9V9H8V8H7V6h2V5h1V3h2v1h1v1h1v1h1z" />
    <path
      {...props}
      d="M21 6V4h-1V3h-1V2h-1V1h-2V0H6v1H4v1H3v1H2v1H1v2H0v2h1v2h1v1h1v1h1v1h2v1h10v-1h2v-1h1v-1h1v-1h1V8h1V6h-1Zm-4 2h-1v2h-1v1h-1v1h-2v1h-2v-1H8v-1H7v-1H6V8H5V6h1V4h1V3h1V2h2V1h2v1h2v1h1v1h1v2h1v2Z"
    />
  </svg>
);

export const FaceThinking = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M11 6h1v1h-2V6H9V5H7v1H5V5h1V4h4v1h1v1zM12 12v1H9v-1H7v-1h3v1h2zM7 7h2v2H7zM13 8h2v2h-2zM18 7v2h-1V8h-1V7h-2V6h3v1h1zM13 14v2h-1v1h-2v2H9v2H8v1H4v-1H3v-6h1v-1h1v3h2v-1h2v-1h2v-1h2z"
    />
    <path
      {...props}
      d="M22 8v6h-1v2h-1v2h-1v1h-1v1h-2v1h-2v1h-4v-2h4v-1h2v-1h1v-1h1v-1h1v-2h1V8h-1V6h-1V5h-1V4h-1V3h-2V2H8v1H6v1H5v1H4v1H3v2H2v5h1v1H2v1H1v-1H0V8h1V6h1V4h1V3h1V2h2V1h2V0h6v1h2v1h2v1h1v1h1v2h1v2h1z"
    />
  </svg>
);

export const FacebookSquare = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path {...props} d="M22 1v20h-1v1h-8v-8h2v-1h1v-2h-3V8h1V7h2V4h-4v1h-2v2H9v4H6v3h3v8H1v-1H0V1h1V0h20v1h1z" />
  </svg>
);

export const Facebook = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M22 8v6h-1v2h-1v2h-1v1h-1v1h-2v1h-2v1h-1v-8h2v-1h1v-2h-3V8h1V7h2V4h-4v1h-2v2H9v4H6v3h3v8H8v-1H6v-1H4v-1H3v-1H2v-2H1v-2H0V8h1V6h1V4h1V3h1V2h2V1h2V0h6v1h2v1h2v1h1v1h1v2h1v2h1z"
    />
  </svg>
);

export const FileImport = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M0 12h5v3H0zM22 7v14h-1v1H6v-1H5v-6h6v4h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h-1v-1h-1v-1h-1v-1h-1V9h-1V8h-1v4H5V1h1V0h9v7h7z"
    />
    <path {...props} d="M22 5v1h-6V0h1v1h1v1h1v1h1v1h1v1h1z" />
  </svg>
);

export const FlagCheckered = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width={width} {...props}>
    <path
      {...props}
      d="M20 2v12h-1v1h-2v1h-6v-1H4v-1h6v-4H4v1H3v4h1v1H3v4H1V3H0V1h1V0h2v1h1v2H3v1h1V3h7v1h6v1h-5v4h5V8h2V4h-2V3h2V2h1z"
    />
  </svg>
);

export const Flag = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width={width} {...props}>
    <path {...props} d="M20 2v12h-1v1h-2v1h-6v-1H4v1H3v4H1V3H0V1h1V0h2v1h1v2H3v1h1V3h7v1h6V3h2V2h1z" />
  </svg>
);

export const Github = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M22 8v6h-1v2h-1v2h-1v1h-1v1h-1v1h-2v1h-1v-5h-1v-1h1v-1h2v-1h1v-1h1V8h-1V5h-2v1h-1v1h-1V6H9v1H8V6H7V5H5v3H4v5h1v1h1v1h2v2H6v-1H5v-1H3v1h1v2h1v1h3v3H7v-1H5v-1H4v-1H3v-1H2v-2H1v-2H0V8h1V6h1V4h1V3h1V2h2V1h2V0h6v1h2v1h2v1h1v1h1v2h1v2h1z"
    />
  </svg>
);

export const GlobeAmericas = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M21 8V6h-1V4h-1V3h-1V2h-2V1h-2V0H8v1H6v1H4v1H3v1H2v2H1v2H0v6h1v2h1v2h1v1h1v1h2v1h2v1h6v-1h2v-1h2v-1h1v-1h1v-2h1v-2h1V8h-1Zm-4 3V8h1V7h1v1h1v4h-2v-1h-1Zm-4 7v2h-2v-3h-1v-1H9v-3H8v-1H7v-1H6v-1H5V9H4V8H3V6h1V5h1V4h1V3h3V2h2v1h1v4h-2v2h1v1H9V9H7v2h3v1h4v1h1v3h-1v2h-1Z"
    />
  </svg>
);

export const GlobeWeb = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width={width} {...props}>
    <g clipPath="url(#clip0_306_2860)">
      <path d="M6.66667 0.666504H6V1.33317H6.66667V0.666504Z" fill="black" />
      <path
        d="M5.99992 1.33325V1.99992H5.33325V3.33325H4.66658V5.33325H1.33325V4.66659H1.99992V3.33325H2.66659V2.66659H3.33325V1.99992H4.66658V1.33325H5.99992Z"
        fill="black"
      />
      <path
        d="M8.66659 1.33317H9.33325V2.6665H9.99992V3.99984H10.6666V5.33317H5.33325V3.99984H5.99992V2.6665H6.66659V1.33317H7.33325V0.666504H8.66659V1.33317Z"
        fill="black"
      />
      <path d="M9.99992 0.666504H9.33325V1.33317H9.99992V0.666504Z" fill="black" />
      <path
        d="M14.6667 4.66659V5.33325H11.3333V3.33325H10.6667V1.99992H10V1.33325H11.3333V1.99992H12.6667V2.66659H13.3333V3.33325H14V4.66659H14.6667Z"
        fill="black"
      />
      <path
        d="M11.3334 6.66667V9.33333H10.6667V10H5.33341V9.33333H4.66675V6.66667H5.33341V6H10.6667V6.66667H11.3334Z"
        fill="black"
      />
      <path d="M0.666748 6H4.66675V6.66667H4.00008V9.33333H4.66675V10H0.666748V6Z" fill="black" />
      <path d="M15.3333 6V10H11.3333V9.33333H11.9999V6.66667H11.3333V6H15.3333Z" fill="black" />
      <path
        d="M14.6667 10.6665V11.3332H14V12.6665H13.3333V13.3332H12.6667V13.9998H11.3333V14.6665H10V13.9998H10.6667V12.6665H11.3333V10.6665H14.6667Z"
        fill="black"
      />
      <path d="M6.66667 14.6665H6V15.3332H6.66667V14.6665Z" fill="black" />
      <path
        d="M5.99992 13.9998V14.6665H4.66658V13.9998H3.33325V13.3332H2.66659V12.6665H1.99992V11.3332H1.33325V10.6665H4.66658V12.6665H5.33325V13.9998H5.99992Z"
        fill="black"
      />
      <path d="M9.99992 14.6665H9.33325V15.3332H9.99992V14.6665Z" fill="black" />
      <path
        d="M9.33325 14.6665H8.66659V15.3332H7.33325V14.6665H6.66659V13.3332H5.99992V11.9998H5.33325V10.6665H10.6666V11.9998H9.99992V13.3332H9.33325V14.6665Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_306_2860">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Google = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M22 9v5h-1v2h-1v2h-1v1h-1v1h-2v1h-2v1H8v-1H6v-1H4v-1H3v-1H2v-2H1v-2H0V8h1V6h1V4h1V3h1V2h2V1h2V0h6v1h2v1h2v2h-1v1h-1v1h-2V5H8v1H6v2H5v6h1v2h2v1h6v-1h2v-2h1v-1h-6V9h11z"
    />
  </svg>
);

export const Headphones = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 21" width={width} {...props}>
    <path
      {...props}
      d="M22 7v11h-1v2h-1v1h-3v-1h-1v-9h1v-1h3v2h1V8h-1V6h-1V5h-1V4h-1V3h-1V2h-2V1H8v1H6v1H5v1H4v1H3v1H2v2H1v4h1v-2h3v1h1v9H5v1H2v-1H1v-2H0V7h1V5h1V4h1V3h1V2h1V1h2V0h8v1h2v1h1v1h1v1h1v1h1v2h1z"
    />
  </svg>
);

export const Heart = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 18" width={width} {...props}>
    <path
      {...props}
      d="M22 3v5h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-2v-1H9v-1H8v-1H7v-1H6v-1H5v-1H4v-1H3v-1H2V9H1V8H0V3h1V2h1V1h1V0h6v1h1v1h2V1h1V0h6v1h1v1h1v1h1z"
    />
  </svg>
);

export const HockeyMask = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 22" width={width} {...props}>
    <path
      {...props}
      d="M15 8h1v2h-1zM14 10h1v1h-1zM12 11h2v1h-2zM11 10h1v1h-1zM11 7h4v1h-4zM10 3h2v2h-2zM10 18h1v1h-1zM10 15h1v1h-1zM10 12h1v1h-1zM10 8h1v2h-1zM8 5h2v2H8zM7 18h1v1H7zM7 15h1v1H7zM7 12h1v1H7zM7 8h1v2H7z"
    />
    <path
      {...props}
      d="M17 5V4h-1V3h-1V2h-1V1h-2V0H6v1H4v1H3v1H2v1H1v1H0v12h1v1h1v1h1v1h1v1h2v1h6v-1h2v-1h1v-1h1v-1h1v-1h1V5h-1Zm0 10h-1v2h-1v1h-1v1h-1v1h-2v1H7v-1H5v-1H4v-1H3v-1H2v-2H1V6h1V5h1V4h1V3h1V2h2V1h4v1h2v1h1v1h1v1h1v2h1v8Z"
    />
    <path {...props} d="M6 10h1v1H6zM6 3h2v2H6zM4 11h2v1H4zM3 10h1v1H3zM3 7h4v1H3zM2 8h1v2H2z" />
  </svg>
);

export const InfoCirlce = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path {...props} d="M13 14v2H9v-2h1V9H9V8h3v6h1zM10 5h2v2h-2z" />
    <path
      {...props}
      d="M21 8V6h-1V4h-1V3h-1V2h-2V1h-2V0H8v1H6v1H4v1H3v1H2v2H1v2H0v6h1v2h1v2h1v1h1v1h2v1h2v1h6v-1h2v-1h2v-1h1v-1h1v-2h1v-2h1V8h-1Zm-1 6h-1v2h-1v1h-1v1h-1v1h-2v1H8v-1H6v-1H5v-1H4v-1H3v-2H2V8h1V6h1V5h1V4h1V3h2V2h6v1h2v1h1v1h1v1h1v2h1v6Z"
    />
  </svg>
);

export const LightbulbLight = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 22" width={width} {...props}>
    <path
      {...props}
      d="M15 6h1v4h-1zM14 10h1v2h-1zM14 4h1v2h-1zM13 12h1v1h-1zM13 3h1v1h-1zM12 13h1v1h-1zM12 2h1v1h-1zM11 14h1v1h-1zM10 1h2v1h-2zM9 20h1v1H9zM6 0h4v1H6zM7 21h2v1H7zM6 20h1v1H6zM6 3h3v1H6zM5 15v5h1v-1h4v1h1v-5H5Zm5 3H6v-2h4v2ZM5 4h1v1H5zM4 1h2v1H4zM4 14h1v1H4zM4 5h1v1H4zM3 13h1v1H3zM3 6h1v2H3zM3 2h1v1H3zM2 12h1v1H2zM2 3h1v1H2zM1 10h1v2H1zM1 4h1v2H1zM0 6h1v4H0z"
    />
  </svg>
);

export const LightbulbOff = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 22" width={width} {...props}>
    <path {...props} d="M10 20v1H9v1H7v-1H6v-1h4zM7 3h2v1H7zM6 4h1v1H6z" />
    <path
      {...props}
      d="M15 6V4h-1V3h-1V2h-1V1h-2V0H6v1H4v1H3v1H2v1H1v2H0v4h1v2h1v1h1v1h1v1h1v4h6v-4h1v-1h1v-1h1v-1h1v-2h1V6h-1Zm-1 4h-1v2h-1v1h-1v1h-1v1H6v-1H5v-1H4v-1H3v-2H2V6h1V4h1V3h2V2h4v1h2v1h1v2h1v4Z"
    />
    <path {...props} d="M5 5h1v1H5zM4 6h1v2H4z" />
  </svg>
);

export const LightbulbOn = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M1 0h1v1H1zM2 1h1v1H2zM3 2h1v1H3zM0 15h1v1H0zM1 14h1v1H1zM2 13h1v1H2zM21 15h1v1h-1zM20 14h1v1h-1zM19 13h1v1h-1zM20 0h1v1h-1zM19 1h1v1h-1zM18 2h1v1h-1zM0 7h2v1H0zM14 17v3h-1v1h-1v1h-2v-1H9v-1H8v-3h6zM18 4h-1V3h-1V2h-1V1h-2V0H9v1H7v1H6v1H5v1H4v2H3v4h1v2h1v1h1v1h1v1h1v1h6v-1h1v-1h1v-1h1v-1h1v-2h1V6h-1V4ZM6 6h1V5h1V4h1V3h3v1H9v1H8v1H7v2H6V6ZM20 7h2v1h-2z"
    />
  </svg>
);

export const Link = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M15 9h1v7h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1H4v-1H3v-1H2v-1H1v-1H0v-5h1v-1h1v-1h1v-1h1v4H3v3h1v1h1v1h3v-1h1v-1h1v-1h1v-1h1v-1h1v-3h-1v-1h-1V9h1V8h1V7h1v1h1v1z"
    />
    <path
      {...props}
      d="M22 4v5h-1v1h-1v1h-1v1h-1V8h1V5h-1V4h-1V3h-3v1h-1v1h-1v1h-1v1h-1v1H9v3h1v1h1v1h-1v1H9v1H8v-1H7v-1H6V6h1V5h1V4h1V3h1V2h1V1h1V0h6v1h1v1h1v1h1v1h1z"
    />
  </svg>
);

export const LockOpen = props => (
  <svg className="hn-lockopen" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 20" width={width} {...props}>
    <path {...props} d="M22 4v5h-3V4h-1V3h-4v1h-1v5h3v1h1v9h-1v1H1v-1H0v-9h1V9h9V4h1V2h1V1h2V0h4v1h2v1h1v2h1z" />
  </svg>
);

export const Lock = props => (
  <svg className="hn-lock" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 22" width={width} {...props}>
    <path
      {...props}
      d="M17 11v-1h-1V5h-1V3h-1V2h-1V1h-2V0H7v1H5v1H4v1H3v2H2v5H1v1H0v10h1v1h16v-1h1V11h-1ZM5 5h1V4h1V3h4v1h1v1h1v5H5V5Z"
    />
  </svg>
);

export const Minus = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 4" width={width} {...props}>
    <path {...props} d="M22 1v2h-1v1H1V3H0V1h1V0h20v1h1z" />
  </svg>
);

export const MoneyBox = props => (
  <svg width="20" height="20" {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      {...props}
      d="M1 9V22H2V23H22V22H23V9H1ZM13 20V22H11V20H9V18H13V17H10V16H9V12H11V10H13V12H15V14H11V15H14V16H15V20H13Z"
      fill="#1E1E1E"
    />
    <path {...props} d="M11 1V7H1V6H2V4H3V3H4V2H5V1H11Z" fill="#1E1E1E" />
    <path {...props} d="M23 6V7H13V1H19V2H20V3H21V4H22V6H23Z" fill="#1E1E1E" />
  </svg>
);

export const Moon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 22" width={width}>
    <path
      {...props}
      d="M20 16v2h-1v1h-1v1h-2v1h-2v1H8v-1H6v-1H4v-1H3v-1H2v-2H1v-2H0V8h1V6h1V4h1V3h1V2h2V1h2V0h5v1h-2v1H9v1H8v2H7v2H6v4h1v2h1v2h1v1h2v1h2v1h4v-1h2v-1h1z"
    />
  </svg>
);

export const NewspaperRegular = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 14" width={width} {...props}>
    <path {...props} d="M21 1V0H2v1H1v1H0v11h1v1h20v-1h1V1h-1ZM3 12H2V2h1v10Zm17 0H5V2h15v10Z" />
    <path {...props} d="M13 9h5v2h-5zM13 6h5v2h-5zM13 3h5v2h-5zM6 3v5h6V3H6Zm4 3H8V5h2v1ZM6 9h6v2H6z" />
  </svg>
);

export const Newspaper = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 14" width={width} {...props}>
    <path
      {...props}
      d="M21 1V0H2v1H1v1H0v11h1v1h20v-1h1V1h-1ZM3 12H2V2h1v10Zm8-2H5V5h6v5Zm9 0h-8V9h8v1Zm-8-2V7h7v1h-7Zm8-2h-8V5h8v1Zm0-2H5V2h15v2Z"
    />
    <path {...props} d="M6 6h4v3H6z" />
  </svg>
);

export const Writing = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} {...props}>
    <path d="M23.5049 7.5012V9.50166H22.5047V10.5019H21.5045V9.50166H20.5043V8.50143H19.504V7.5012H20.5043V6.50098H22.5047V7.5012H23.5049Z" />
    <path d="M21.5046 10.5019V11.5021H20.5044V12.5024H19.5041V13.5026H18.5039V14.5028H17.5037V15.5031H16.5035V16.5033H15.5032V17.5035H14.503V18.5037H11.5023V15.5031H12.5025V14.5028H13.5028V13.5026H14.503V12.5024H15.5032V11.5021H16.5035V10.5019H17.5037V9.50169H18.5039V8.50146H19.5041V9.50169H20.5044V10.5019H21.5046Z" />
    <path d="M17.5036 2.50023V1.5H2.50023V2.50023H1.5V22.5048H2.50023V23.505H17.5036V22.5048H18.5039V16.5034H17.5036V17.5036H16.5034V18.5039H15.5032V19.5041H10.502V14.503H11.5023V13.5027H12.5025V12.5025H13.5027V11.5023H14.503V10.502H15.5032V9.50182H16.5034V8.50159H17.5036V7.50136H18.5039V2.50023H17.5036ZM16.5034 5.50091H3.50045V4.50068H16.5034V5.50091ZM14.503 8.50159H3.50045V7.50136H14.503V8.50159ZM8.50159 17.5036H3.50045V16.5034H8.50159V17.5036ZM3.50045 14.503V13.5027H9.50182V14.503H3.50045ZM3.50045 11.5023V10.502H12.5025V11.5023H3.50045Z" />
  </svg>
);

export const SoundOn = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} {...props}>
    <polygon points="17 15 17 14 16 14 16 13 17 13 17 11 16 11 16 10 17 10 17 9 18 9 18 10 19 10 19 14 18 14 18 15 17 15" />
    <polygon points="23 10 23 14 22 14 22 16 21 16 21 17 20 17 20 18 19 18 19 17 18 17 18 16 19 16 19 15 20 15 20 14 21 14 21 10 20 10 20 9 19 9 19 8 18 8 18 7 19 7 19 6 20 6 20 7 21 7 21 8 22 8 22 10 23 10" />
    <path d="m11,2v1h-1v1h-1v1h-1v1h-1v1h-1v1H1v8h5v1h1v1h1v1h1v1h1v1h1v1h3V2h-3Zm1,17h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1H3v-4h4v-1h1v-1h1v-1h1v-1h1v-1h1v14Z" />
  </svg>
);

export const SoundOff = props => (
  <svg id="sound-mute" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} {...props}>
    <polygon points="22 8 22 10 21 10 21 11 20 11 20 13 21 13 21 14 22 14 22 16 20 16 20 15 19 15 19 14 18 14 18 15 17 15 17 16 15 16 15 14 16 14 16 13 17 13 17 11 16 11 16 10 15 10 15 8 17 8 17 9 18 9 18 10 19 10 19 9 20 9 20 8 22 8" />
    <path d="m11,2v1h-1v1h-1v1h-1v1h-1v1h-1v1H1v8h5v1h1v1h1v1h1v1h1v1h1v1h3V2h-3ZM3,10h4v-1h1v-1h1v-1h1v-1h1v-1h1v14h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1H3v-4Z" />
  </svg>
);

export const Pause = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path {...props} d="M22 1v20h-1v1h-7v-1h-1V1h1V0h7v1h1zM8 1h1v20H8v1H1v-1H0V1h1V0h7v1z" />
  </svg>
);

export const PenNib = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M22 3v3h-1v1h-1v1h-1v1h-1V8h-1V7h-1V6h-1V5h-1V4h-1V3h1V2h1V1h1V0h3v1h1v1h1v1h1zM17 10h1v1h-1v3h-1v3h-1v1h-2v1h-3v1H7v1H4v1H2v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h3v-3h-1v-1H7v3H6v1H5v1H4v1H3v1H2v1H1v1H0v-2h1v-3h1v-3h1V9h1V7h1V6h3V5h3V4h1v1h1v1h1v1h1v1h1v1h1v1z"
    />
  </svg>
);

export const Pen = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M16 9h1v2h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1H9v1H8v1H7v1H6v1H0v-6h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1V9h1V8h1V7h1V6h1V5h2v1h1v1h1v1h1v1zM22 4v2h-1v1h-1v1h-1v1h-1V8h-1V7h-1V6h-1V5h-1V4h-1V3h1V2h1V1h1V0h2v1h1v1h1v1h1v1h1z"
    />
  </svg>
);

export const PencilLight = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M21 4V3h-1V2h-1V1h-1V0h-2v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1H9v1H8v1H7v1H6v1H5v1H4v1H3v1H2v1H1v1H0v6h6v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1V9h1V8h1V7h1V6h1V4h-1ZM6 19v1H5v1H2v-1H1v-3h1v-1h1v-1h1v1h1v1h1v1h1v1H6Zm9-9v1h-1v1h-1v1h-1v1h-1v1h-1v1H9v1H7v-1H6v-1H5v-2h1v-1h1v-1h1v-1h1V9h1V8h1V7h1V6h2v1h1v1h1v2h-1Zm4-4v1h-1v1h-1V7h-1V6h-1V5h-1V4h1V3h1V2h2v1h1v1h1v2h-1Z"
    />
  </svg>
);

export const PencilRuler = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      {...props}
      d="M18 10V9h1V8h1V7h1V6h1V3h-1V2h-1V1h-1V0h-3v1h-1v1h-1v1h-1v1h-1v1h-2V4H9V3H8V2H7V1H6V0H4v1H3v1H2v1H1v1H0v2h1v1h1v1h1v1h1v1h1v2H4v1H3v1H2v1H1v1H0v6h6v-1h1v-1h1v-1h1v-1h1v-1h2v1h1v1h1v1h1v1h1v1h2v-1h1v-1h1v-1h1v-1h1v-2h-1v-1h-1v-1h-1v-1h-1v-1h-1v-2h1ZM6 9V8H5V7H4V6H3V4h1V3h2v1h1v1H6v1h1v1h1V6h1v2H8v1H6Zm6 3v1h-1v1h-1v1H9v1H8v1H7v1H6v1H5v1H2v-3h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1V9h1V8h1V7h1V6h1v1h1v1h1v1h-1v1h-1v1h-1v1h-1Zm6 3v1h1v2h-1v1h-2v-1h-1v-1h-1v-1h-1v-2h1v-1h2v1h-1v1h1v1h1v-1h1Zm-2-9V5h-1V4h1V3h1V2h1v1h1v1h1v1h-1v1h-1v1h-1V6h-1Z"
    />
  </svg>
);

export const Pencil = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      {...props}
      d="M21 3V2h-1V1h-1V0h-4v1h-1v1h-1v1h-1v1h-1v1h-1v1H9v1H8v1H7v1H6v1H5v1H4v1H3v1H2v1H1v1H0v7h7v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1V9h1V8h1V7h1V3h-1ZM7 19H6v1H3v-1H2v-3h1v-1h1v1h1v1h1v1h1v1Zm9-9h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1H9v1H8v-1H7v-1H6v-1H5v-1h1v-1h1v-1h1v-1h1V9h1V8h1V7h1V6h2v1h1v1h1v2Zm1-3V6h-1V5h-1V3h1V2h2v1h1v1h1v2h-1v1h-2Z"
    />
  </svg>
);

export const PeopleCarry = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 19" width={width} {...props}>
    <path
      {...props}
      {...props}
      d="M2 15h1v1H2v2H0v-3h1v-1h1v1zM3 3H2V1h1V0h2v1h1v2H5v1H3V3zM22 15v3h-2v-2h-1v-1h1v-1h1v1h1z"
    />
    <path
      {...props}
      {...props}
      d="M19 14h-1v4h-1v1h-1v-1h-1v-3h1v-3h1v-2h-1v1h-1v1H7v-1H6v-1H5v2h1v3h1v3H6v1H5v-1H4v-4H3v-1H2v-1H1V9h1V6h1V5h2v1h1v2h1v1h1V5h6v4h1V8h1V6h1V5h2v1h1v3h1v3h-1v1h-1v1zM17 3h-1V1h1V0h2v1h1v2h-1v1h-2V3z"
    />
  </svg>
);

export const PlaneDeparture = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 17" width={width} {...props}>
    <path
      {...props}
      {...props}
      d="M22 1v4h-1v1h-2v1h-2v1h-2v1h-2v1h-2v1H9v1H3v-1H2v-1H1V9H0V7h1V6h2v1h1v1h2V7h1V6H6V5H5V4H4V3H3V2h1V1h1V0h1v1h2v1h2v1h2v1h2V3h2V2h2V1h4zM0 15h22v2H0z"
    />
  </svg>
);

export const Play = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 22" width={width} {...props}>
    <path
      {...props}
      {...props}
      d="M20 10v2h-1v1h-1v1h-2v1h-2v1h-1v1h-2v1H9v1H8v1H6v1H4v1H1v-1H0V1h1V0h3v1h2v1h2v1h1v1h2v1h2v1h1v1h2v1h2v1h1v1h1z"
    />
  </svg>
);

export const Plus = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path {...props} {...props} d="M22 10v2h-1v1h-8v8h-1v1h-2v-1H9v-8H1v-1H0v-2h1V9h8V1h1V0h2v1h1v8h8v1h1z" />
  </svg>
);

export const Question = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 22" width={width} {...props}>
    <path
      {...props}
      {...props}
      d="M9 16h1v1H9zM10 17h1v3h-1zM9 20h1v1H9zM5 20h1v1H5zM6 21h3v1H6zM5 16h1v1H5zM4 17h1v3H4zM11 11h2v1h-2zM13 10h1v1h-1zM14 4h1v6h-1zM13 3h1v1h-1zM12 2h1v1h-1zM11 1h1v1h-1zM5 0h6v1H5zM3 1h2v1H3zM2 2h1v1H2zM1 3h1v1H1zM0 4h1v1H0zM1 5h1v1H1zM2 6h1v1H2zM3 7h1v1H3zM4 8h1v1H4zM5 7h1v1H5zM6 6h1v1H6zM7 5h2v1H7zM9 6h1v2H9zM7 8h2v1H7zM6 9h1v1H6zM5 10h1v1H5zM4 11h1v3H4zM10 14v1H9v1H6v-1H5v-1h5zM10 12h1v2h-1z"
    />
  </svg>
);

export const FilledQuestion = props => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      {...props}
      d="M18 5V11H17V12H15V13H14V15H9V12H10V11H11V10H13V9H14V7H13V6H11V7H10V8H9V9H8V8H7V7H6V6H5V5H6V4H7V3H9V2H15V3H16V4H17V5H18Z"
    />

    <path {...props} d="M13 18H14V21H13V22H10V21H9V18H10V17H13V18Z" />
  </svg>
);

export const QuoteLeft = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 20" width={width} {...props}>
    <path
      {...props}
      {...props}
      d="M9 11h1v8H9v1H1v-1H0V5h1V3h1V2h1V1h2V0h2v1h1v3H7v1H5v1H4v4h5v1zM22 11v8h-1v1h-8v-1h-1V5h1V3h1V2h1V1h2V0h2v1h1v3h-1v1h-2v1h-1v4h5v1h1z"
    />
  </svg>
);

export const QuoteRight = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 20" width={width} {...props}>
    <path
      {...props}
      {...props}
      d="M9 1h1v14H9v2H8v1H7v1H5v1H3v-1H2v-3h1v-1h2v-1h1v-4H1V9H0V1h1V0h8v1zM22 1v14h-1v2h-1v1h-1v1h-2v1h-2v-1h-1v-3h1v-1h2v-1h1v-4h-5V9h-1V1h1V0h8v1h1z"
    />
  </svg>
);

export const Receipt = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 22" width={width} {...props}>
    <path
      {...props}
      {...props}
      d="M15 0v1h-1v1h-1V1h-1V0h-2v1H9v1H7V1H6V0H4v1H3v1H2V1H1V0H0v22h1v-1h1v-1h1v1h1v1h2v-1h1v-1h2v1h1v1h2v-1h1v-1h1v1h1v1h1V0h-1Zm-1 8H2V6h12v2Zm0 4H2v-2h12v2Zm0 4H2v-2h12v2Z"
    />
  </svg>
);

export const Refresh = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M22 13v1h-1v2h-1v2h-1v1h-1v1h-2v1h-2v1H8v-1H6v-1H4v-1H2v1H1v1H0v-8h8v1H7v1H6v2h1v1h2v1h4v-1h2v-1h1v-1h1v-2h1v-1h4zM22 1v8h-8V8h1V7h1V5h-1V4h-2V3H9v1H7v1H6v1H5v2H4v1H0V8h1V6h1V4h1V3h1V2h2V1h2V0h6v1h2v1h2v1h2V2h1V1h1z"
    />
  </svg>
);

export const RetroCamera = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 20" width={width} {...props}>
    <path
      {...props}
      d="M21 1V0H1v1H0v18h1v1h20v-1h1V1h-1ZM2 2h6v1H2V2Zm14 13h-1v2h-2v1H9v-1H7v-2H6v-4h1V9h2V8h4v1h2v2h1v4Zm4-9H2V5h6V4h1V3h1V2h10v4Z"
    />
    <path {...props} d="M14 11v4h-1v1H9v-1H8v-4h1v3h1v-2h2v-1H9v-1h4v1h1z" />
  </svg>
);

export const Robot = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 17" width={width} {...props}>
    <path
      {...props}
      d="M1 7h1v7H1v-1H0V8h1V7zM18 4h-1V3h-5V0h-2v3H5v1H4v1H3v10h1v1h1v1h12v-1h1v-1h1V5h-1V4Zm-2 6h-3V7h3v3Zm-4 4h-2v-1h2v1Zm-6-1h3v1H6v-1Zm0-6h3v3H6V7Zm7 7v-1h3v1h-3ZM22 8v5h-1v1h-1V7h1v1h1z"
    />
  </svg>
);

export const Save = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M21 6V5h-1V4h-1V3h-1V2h-1V1h-1V0H1v1H0v20h1v1h20v-1h1V6h-1ZM8 18v-4h1v-1h4v1h1v4h-1v1H9v-1H8Zm7-9H3V3h12v6Z"
    />
  </svg>
);

export const Search = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M21 19v-1h-1v-1h-1v-1h-1v-1h-2v-1h1v-2h1V6h-1V4h-1V3h-1V2h-1V1h-2V0H6v1H4v1H3v1H2v1H1v2H0v6h1v2h1v1h1v1h1v1h2v1h6v-1h2v-1h1v2h1v1h1v1h1v1h1v1h2v-1h1v-2h-1Zm-10-5v1H7v-1H5v-1H4v-2H3V7h1V5h1V4h2V3h4v1h2v1h1v2h1v4h-1v2h-1v1h-2Z"
    />
  </svg>
);

export const Seedlings = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 20" width={width} {...props}>
    <path
      {...props}
      d="M11 9h1v11h-2v-7H6v-1H4v-1H3v-1H2V8H1V6H0V3h5v1h2v1h2v1h1v1h1v2zM22 0v4h-1v2h-1v1h-1v1h-2v1h-2v1h-2V8h-1V6h-1V4h1V3h1V2h2V1h2V0h5z"
    />
  </svg>
);

export const ShareAlt = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 22" width={width} {...props}>
    <path
      {...props}
      d="M20 3v2h-1v2h-1v1h-5V7h-2v1h-1v1H9v4h1v1h1v1h2v-1h5v1h1v2h1v2h-1v2h-1v1h-5v-1h-1v-2h-1v-2h-1v-1H9v-1H8v-1H7v1H2v-1H1v-2H0v-2h1V8h1V7h5v1h1V7h1V6h1V5h1V3h1V1h1V0h5v1h1v2h1z"
    />
  </svg>
);

export const Shop = props => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path {...props} d="M23 7V9H22V10H2V9H1V7H2V6H3V4H4V3H20V4H21V6H22V7H23Z" fill="#1E1E1E" />
    <path {...props} d="M14 11V20H13V21H4V20H3V11H5V16H12V11H14Z" fill="#1E1E1E" />
    <path {...props} d="M21 11H19V21H21V11Z" fill="#1E1E1E" />
  </svg>
);

export const Sort = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 22" width={width} {...props}>
    <path
      {...props}
      d="M16 7v2h-1v1H1V9H0V7h1V6h1V5h1V4h1V3h1V2h1V1h1V0h2v1h1v1h1v1h1v1h1v1h1v1h1v1h1zM16 13v2h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1H9v1H7v-1H6v-1H5v-1H4v-1H3v-1H2v-1H1v-1H0v-2h1v-1h14v1h1z"
    />
  </svg>
);

export const SpinnerThird = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 16" width={width} {...props}>
    <path {...props} d="M11 8v6h-1v2H8v-2h1V8H8V6H7V4H5V3H3V2H0V0h3v1h2v1h2v1h1v1h1v2h1v2h1z" />
  </svg>
);

export const Spinner = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M6 4h1v2H6v1H4V6H3V4h1V3h2v1zM12 1h1v2h-1v1h-2V3H9V1h1V0h2v1zM3 13H1v-1H0v-2h1V9h2v1h1v2H3v1zM6 16h1v2H6v1H4v-1H3v-2h1v-1h2v1zM22 10v2h-1v1h-2v-1h-1v-2h1V9h2v1h1zM18 16h1v2h-1v1h-2v-1h-1v-2h1v-1h2v1zM12 19h1v2h-1v1h-2v-1H9v-2h1v-1h2v1z"
    />
  </svg>
);

export const Star = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M22 7v2h-1v1h-1v1h-1v1h-1v1h-1v5h1v4h-2v-1h-2v-1h-2v-1h-2v1H8v1H6v1H4v-4h1v-5H4v-1H3v-1H2v-1H1V9H0V7h7V5h1V3h1V1h1V0h2v1h1v2h1v2h1v2h7z"
    />
  </svg>
);

export const InfoWarning = props => (
  <svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" width={width} {...props}>
    <path
      d="M21.7632 17.31C21.2983 16.32 20.7404 15.06 20.0895 13.89C19.4387 12.63 18.7878 11.46 18.2299 10.38C17.1141 8.4 15.3474 5.88 14.0456 4.08C13.5807 3.45 12.8368 3 12 3C11.1632 3 10.4193 3.36 9.95437 4.08C8.65261 5.88 6.97891 8.4 5.77013 10.38C4.56135 12.45 3.1666 15.33 2.23677 17.31C1.86484 18.03 1.95782 18.93 2.32976 19.56C2.79467 20.28 3.53854 20.64 4.37538 20.73C6.60698 20.82 9.67542 21 12 21C14.3246 21 17.486 20.82 19.6246 20.73C20.4615 20.73 21.2053 20.28 21.6702 19.56C22.0422 18.93 22.1352 18.03 21.7632 17.31ZM12.7439 16.77C12.7439 17.13 12.4649 17.49 12 17.49C11.5351 17.49 11.2561 17.22 11.2561 16.77V13.17C11.2561 12.81 11.5351 12.45 12 12.45C12.4649 12.45 12.7439 12.72 12.7439 13.17V16.77ZM12 11.37C11.5351 11.37 11.0702 10.92 11.0702 10.47C11.0702 10.02 11.5351 9.57 12 9.57C12.4649 9.57 12.9298 10.02 12.9298 10.47C12.9298 10.92 12.4649 11.37 12 11.37Z"
      fill="#000000"
    />
  </svg>
);

export const StarCresent = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M13 20h3v1h-2v1H8v-1H6v-1H4v-1H3v-1H2v-2H1v-2H0V8h1V6h1V4h1V3h1V2h2V1h2V0h6v1h2v1h-3v1h-2v1H9v1H8v2H7v2H6v4h1v2h1v2h1v1h2v1h2v1z"
    />
    <path
      {...props}
      d="M22 9v1h-1v1h-1v2h1v3h-1v-1h-1v-1h-1v-1h-1v1h-1v1h-1v1h-1v-3h1v-2h-1v-1h-1V9h3V7h1V6h1v1h1v2h3z"
    />
  </svg>
);

export const Sun = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path {...props} d="M16 9v4h-1v1h-1v1h-1v1H9v-1H8v-1H7v-1H6V9h1V8h1V7h1V6h4v1h1v1h1v1h1z" />
    <path
      {...props}
      d="M20 10V9h1V8h1V6h-3V5h-2V3h-1V0h-2v1h-1v1h-1v1h-2V2H9V1H8V0H6v3H5v2H3v1H0v2h1v1h1v1h1v2H2v1H1v1H0v2h3v1h2v2h1v3h2v-1h1v-1h1v-1h2v1h1v1h1v1h2v-3h1v-2h2v-1h3v-2h-1v-1h-1v-1h-1v-2h1Zm-3 4h-1v1h-1v1h-1v1H8v-1H7v-1H6v-1H5V8h1V7h1V6h1V5h6v1h1v1h1v1h1v6Z"
    />
  </svg>
);

export const Trending = props => (
  <svg height="14" viewBox="0 0 23 14" xmlns="http://www.w3.org/2000/svg" width={width} {...props}>
    <path d="M-3.05176e-05 11L0 8.4H1.4V7H2.8V5.6H4.2V4.2H5.6V5.6H7V7H8.4V8.4H9.8V9.8H11.2V8.4H12.6V7H14V5.6H15.4V2.8H14V1.4H12.6V0H22.4V9.8H21V8.4H19.6V7H16.8V8.4H15.4V9.8H14V11.2H12.6V12.6H11.2V14H9.8V12.6H8.4V11.2H7V9.8H5.6V8.4H4.2V9.8H2.8V11H1.99997V12H0.999969H-3.05176e-05V11Z" />
  </svg>
);

export const Tag = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M21 12v-1h-1v-1h-1V9h-1V8h-1V7h-1V6h-1V5h-1V4h-1V3h-1V2h-1V1h-1V0H1v1H0v9h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h2v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-2h-1ZM3 4h1V3h2v1h1v2H6v1H4V6H3V4Z"
    />
  </svg>
);

export const TimesCircle = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M13 12h1v1h1v1h1v1h-1v1h-1v-1h-1v-1h-1v-1h-2v1H9v1H8v1H7v-1H6v-1h1v-1h1v-1h1v-2H8V9H7V8H6V7h1V6h1v1h1v1h1v1h2V8h1V7h1V6h1v1h1v1h-1v1h-1v1h-1v2z"
    />
    <path
      {...props}
      d="M21 8V6h-1V4h-1V3h-1V2h-2V1h-2V0H8v1H6v1H4v1H3v1H2v2H1v2H0v6h1v2h1v2h1v1h1v1h2v1h2v1h6v-1h2v-1h2v-1h1v-1h1v-2h1v-2h1V8h-1Zm-1 6h-1v2h-1v2h-2v1h-2v1H8v-1H6v-1H4v-2H3v-2H2V8h1V6h1V4h2V3h2V2h6v1h2v1h2v2h1v2h1v6Z"
    />
  </svg>
);

export const TimesLight = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M22 0v2h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v2h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v2h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-2v1H9v1H8v1H7v1H6v1H5v1H4v1H3v1H2v1H1v1H0v-2h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-2H8V9H7V8H6V7H5V6H4V5H3V4H2V3H1V2H0V0h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h1v1h2V9h1V8h1V7h1V6h1V5h1V4h1V3h1V2h1V1h1V0h1z"
    />
  </svg>
);

export const TimesOctagon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M21 7V6h-1V5h-1V4h-1V3h-1V2h-1V1h-1V0H7v1H6v1H5v1H4v1H3v1H2v1H1v1H0v8h1v1h1v1h1v1h1v1h1v1h1v1h1v1h8v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1V7h-1Zm-6 9h-2v-1h-1v-1h-2v1H9v1H7v-1H6v-2h1v-1h1v-2H7V9H6V7h1V6h2v1h1v1h2V7h1V6h2v1h1v2h-1v1h-1v2h1v1h1v2h-1v1Z"
    />
  </svg>
);

export const TrashAlt = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 22" width={width} {...props}>
    <path
      {...props}
      d="M16 4V3h-1V2h-1V1h-1V0H7v1H6v1H5v1H4v1H0v2h2v15h1v1h14v-2h1V6h1V4h-3ZM6 3h1V2h6v1h1v1H6V3Zm10 17H4V6h12v14Z"
    />
    <path {...props} d="M6 8h2v10H6zM12 8h2v10h-2z" />
  </svg>
);

export const Thumbtack = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 22" width={width} {...props}>
    <path {...props} d="M14 12v2h-1v1H8v7H6v-7H1v-1H0v-2h1v-1h1v-1h1V3H1V1h1V0h10v1h1v2h-2v7h1v1h1v1h1z" />
  </svg>
);

export const Trash = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 22" width={width} {...props}>
    <path {...props} d="M17 5v8h-1v8h-1v1H3v-1H2v-8H1V5h16zM18 2v2H0V2h1V1h5V0h6v1h5v1h1z" />
  </svg>
);

export const Twitter = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 18" width={width} {...props}>
    <path
      {...props}
      d="M21 2h1v1h-1zM21 0h1v1h-1zM20 2v1h1v1h-1v5h-1v2h-1v2h-1v1h-1v1h-1v1h-2v1h-3v1H3v-1H1v-1H0v-1h2v1h3v-1h1v-1H4v-1H3v-1H2v-1h2v-1H2V9H1V7h2V6H2V5H1V1h1v1h1v1h1v1h2v1h3v1h2V2h1V1h1V0h5v1h3v1h-1z"
    />
  </svg>
);

export const Unlock = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 22" width={width} {...props}>
    <path
      {...props}
      d="M19 11v-1H6V4h1V3h1V2h4v1h1v1h1v4h2V4h-1V2h-1V1h-2V0H8v1H6v1H5v2H4v6H1v1H0v10h1v1h18v-1h1V11h-1Zm-1 9H2v-8h16v8Z"
    />
  </svg>
);

export const Upload = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M21 15h1v6h-1zM18 18h1v1h-1zM16 18h1v1h-1zM8 17h6v1H8zM1 21h20v1H1zM21 14v1h-6v2h-1V8h4V7h-1V6h-1V5h-1V4h-1V3h-1V2h-1V1h-2v1H9v1H8v1H7v1H6v1H5v1H4v1h4v9H7v-2H1v-1h6V9H3V6h1V5h1V4h1V3h1V2h1V1h1V0h4v1h1v1h1v1h1v1h1v1h1v1h1v3h-4v5h6zM0 15h1v6H0z"
    />
  </svg>
);

export const UploadFill = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} {...props}>
    <path {...props} d="m22,16v-1h-6v3h-1v1h-6v-1h-1v-3H2v1h-1v6h1v1h20v-1h1v-6h-1Zm-4,4h-1v-1h1v1Zm2,0h-1v-1h1v1Z" />
    <polygon points="19 7 19 8 15 8 15 17 14 17 14 18 10 18 10 17 9 17 9 8 5 8 5 7 6 7 6 6 7 6 7 5 8 5 8 4 9 4 9 3 10 3 10 2 11 2 11 1 13 1 13 2 14 2 14 3 15 3 15 4 16 4 16 5 17 5 17 6 18 6 18 7 19 7" />
  </svg>
);

export const UserCheck = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 18" width={width} {...props}>
    <path
      {...props}
      d="M22 6v1h-1v1h-1v1h-1v1h-1v1h-2v-1h-1V9h-1V8h1V7h1v1h2V7h1V6h1V5h1v1h1zM12 3v3h-1v2H9v1H6V8H4V6H3V3h1V1h2V0h3v1h2v2h1zM15 13v4h-1v1H1v-1H0v-4h1v-1h1v-1h1v-1h2v1h5v-1h2v1h1v1h1v1h1z"
    />
  </svg>
);

export const UserHeadset = props => (
  <svg xmlns="http://www.w3.org/2000/svg" widths={20} height={20} viewBox="0 0 20 22" width={width} {...props}>
    <path
      {...props}
      d="M18 5v6h-1v1h-1v1h-2v1H8v-3h3v1h4v-1h1v-1h1V6h-1V4h-1V3h-1V2h-1V1H7v1H6v1H5v1H4v2H3v4H2V9H1V6h1V5h1V3h1V2h1V1h1V0h8v1h1v1h1v1h1v2h1z"
    />
    <path
      {...props}
      d="M16 7v2h-1v1h-1v1h-2v-1H7v3H6v-1H5v-1H4V7h1V5h1V4h1V3h6v1h1v1h1v2h1zM20 18v3h-1v1H1v-1H0v-3h1v-1h1v-1h1v-1h4v1h6v-1h4v1h1v1h1v1h1z"
    />
  </svg>
);

export const User = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 22" width={width} {...props}>
    <path
      {...props}
      d="M5 8H4V4h1V2h1V1h2V0h4v1h2v1h1v2h1v4h-1v2h-1v1h-2v1H8v-1H6v-1H5V8zM20 18v3h-1v1H1v-1H0v-3h1v-1h1v-1h1v-1h2v-1h10v1h2v1h1v1h1v1h1z"
    />
  </svg>
);

export const UsersCrown = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 18" width={width} {...props}>
    <path {...props} d="M15 17h-1v1H1v-1H0v-3h1v-1h1v-1h1v-1h9v1h1v1h1v1h1v3zM12 9V8h1V2h4v1h1v5h-1v1h-5z" />
    <path
      {...props}
      d="M22 14v3h-1v1h-6v-1h1v-4h-1v-1h-1v-1h5v1h1v1h1v1h1zM11 0v1h-1v1H9V1H8V0H7v1H6v1H5V1H4V0H3v7h1v1h1v1h5V8h1V7h1V0h-1Zm-1 6H9v1H6V6H5V4h5v2Z"
    />
  </svg>
);

export const Users = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 18" width={width} {...props}>
    <path
      {...props}
      d="M1 9V8H0V6h1V5h5v3h1v1H1zM4 3H3V1h1V0h2v1h1v1H6v2H4V3zM7 3h1V2h1V1h4v1h1v1h1v4h-1v1h-1v1H9V8H8V7H7V3zM18 14h1v3h-1v1H4v-1H3v-3h1v-1h1v-1h2v-1h8v1h2v1h1v1zM22 6v2h-1v1h-6V8h1V5h5v1h1zM16 2h-1V1h1V0h2v1h1v2h-1v1h-2V2z"
    />
  </svg>
);

export const VoteYeah = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 16" width={width} {...props}>
    <path {...props} d="M17 1V0H5v1H4v12h14V1h-1Zm-2 4h-1v1h-1v1h-1v1h-1v1H9V8H8V7H7V6h1V5h1v1h2V5h1V4h1V3h1v1h1v1Z" />
    <path {...props} d="M22 11v4h-1v1H1v-1H0v-4h1v-1h2v2H2v2h18v-2h-1v-2h2v1h1z" />
  </svg>
);

export const IndentLeft = props => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 231 231">
    <g>
      <rect width="230" x="0.5" y="198" height="33" />
      <rect width="131" x="1.5" y="133" height="33" />
      <rect width="131" x="1.5" y="66" height="33" />
      <rect width="230" x="0.5" height="33" />
      <polygon points="197.5,83 148.5,116 197.5,149 197.5,132 230.5,132 230.5,99 197.5,99  " />
    </g>
  </svg>
);

export const IndentRight = props => (
  <svg {...props} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 231 231">
    <g>
      <rect width="230" x="0.5" y="198" height="33" />
      <rect width="131" x="99.5" y="133" height="33" />
      <rect width="131" x="99.5" y="66" height="33" />
      <rect width="230" x="0.5" height="33" />
      <polygon points="33.5,149 82.5,116 33.5,83 33.5,100 0.5,100 0.5,133 33.5,133  " />
    </g>
  </svg>
);

export const BulletList = () => (
  <svg viewBox="0 0 24 18">
    <line stroke="#000000" strokeWidth="2" x1="6" x2="18" y1="4" y2="4"></line>
    <line stroke="#000000" strokeWidth="2" x1="6" x2="18" y1="10" y2="10"></line>
    <line stroke="#000000" strokeWidth="2" x1="6" x2="18" y1="16" y2="16"></line>
    <line
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      stroke="#000000"
      x1="3"
      x2="3"
      y1="4"
      y2="4"
    ></line>
    <line
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      stroke="#000000"
      x1="3"
      x2="3"
      y1="10"
      y2="10"
    ></line>
    <line
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      stroke="#000000"
      x1="3"
      x2="3"
      y1="16"
      y2="16"
    ></line>
  </svg>
);

export const CleanFormat = () => (
  <svg className="" viewBox="0 0 18 18">
    <line className="ql-stroke" x1="5" x2="13" y1="3" y2="3"></line>
    <line className="ql-stroke" x1="6" x2="9.35" y1="12" y2="3"></line>
    <line className="ql-stroke" x1="11" x2="15" y1="11" y2="15"></line>
    <line className="ql-stroke" x1="15" x2="11" y1="11" y2="15"></line>
    <rect className="ql-fill" height="1" rx="0.5" ry="0.5" width="7" x="2" y="14"></rect>
  </svg>
);

export const Wallet = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 20" width={width} {...props}>
    <path {...props} d="M21 6V5H3V3h18V1h-1V0H1v1H0v18h1v1h20v-1h1V6h-1Zm-1 7h-1v1h-2v-1h-1v-2h1v-1h2v1h1v2Z" />
  </svg>
);

export const WindowClose = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width={width} {...props}>
    <path
      {...props}
      d="M21 1V0H1v1H0v20h1v1h20v-1h1V1h-1Zm-4 7h-1v1h-1v1h-1v2h1v1h1v1h1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h-2v1H9v1H8v1H7v-1H6v-1H5v-1h1v-1h1v-1h1v-2H7V9H6V8H5V7h1V6h1V5h1v1h1v1h1v1h2V7h1V6h1V5h1v1h1v1h1v1Z"
    />
  </svg>
);

export const Pinterest = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M23 9v6h-1v2h-1v2h-1v1h-1v1h-2v1h-2v1H9v-2h1v-3h1v-1h1v1h4v-1h1v-1h1v-2h1v-4h-1V8h-1V7h-1V6h-2V5h-4v1H8v1H7v1H6v2H5v4h1v1h1v1h1v-2H7v-4h1V8h2V7h4v1h2v1h1v5h-1v1h-1v1h-4v-2h1V9h-2v1H9v7H8v3H7v1H5v-1H4v-1H3v-2H2v-2H1V9h1V7h1V5h1V4h1V3h2V2h2V1h6v1h2v1h2v1h1v1h1v2h1v2h1z" />
  </svg>
);
export const Giphy = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M20 9h1v14H3V1h9v1h-1v1H5v18h14V10h1V9z" />
    <path d="M21 6v2h-8V1h2v2h3v3h3z" />
  </svg>
);

export const GoogleNews = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M20 10V9H4v1H3v11h1v1h16v-1h1V10h-1Zm-7 3h5v1h-5v-1Zm-2 5h-1v1H6v-1H5v-4h1v-1h4v1H7v1H6v2h1v1h2v-1h1v-1H8v-1h3v3Zm7 0h-5v-1h5v1Zm-5-2v-1h6v1h-6Z" />
    <path d="M23 8v4h-1V9h-1V8h-5V6h3v1h3v1h1zM15 3h-5v1H7v1H5V3h1V2h12v1h1v2h-4V3z" />
    <path d="M14 6h1v2H3v1H2v3H1V8h1V7h3V6h3V5h3V4h3v2z" />
  </svg>
);

export const Mastodon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M22 7V4h-1V3h-1V2h-1V1H5v1H4v1H3v1H2v3H1v9h1v3h1v1h1v1h1v1h2v1h7v-1h2v-2H9v-1H8v-2h1v1h9v-1h2v-1h1v-1h1v-2h1V7h-1Zm-3 7h-3V7h-2v1h-1v4h-2V8h-1V7H8v7H5V6h1V5h1V4h3v1h1v1h2V5h1V4h3v1h1v1h1v8Z" />
  </svg>
);

export const Minds = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M15 18v4h-1v1h-4v-1H9v-4h6zM19 5v7h-1v1h-1v1h-1v3H8v-3H7v-1H6v-1H5V5h1V4h1V3h1V2h1V1h6v1h1v1h1v1h1v1h1z" />
  </svg>
);

export const Imgur = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M15 17h1v1h-1zM15 17v-1h-2v1h-1v1h-1v1h1v1h-1v-1h-1v1H8v-1H7v-1H6v-1H5v-2H4v1H3v-1H2v-1h1v-1h1v1h1v-1h1v-1h1v-1H6v-1h1v1h1V9H7V8H6v1H5v1H4v1H3v1H1v9h1v1h1v1h8v-1h1v-1h1v-1h1v-1h1v-1h-1v-1h1ZM3 20H2v-1h1v1Zm0-3h1v1H3v-1Zm4 4H6v1H5v-1H4v-1h1v-1h1v1h1v1Zm3 1H9v-1h1v1Z" />
    <path d="M23 3v18h-1v1h-1v1h-8v-1h1v-1h1v-1h1v-1h1v-1h1v-1h1V5H7v1H6v1H5v1H4v1H3v1H2v1H1V3h1V2h1V1h18v1h1v1h1z" />
    <path d="M13 15h-1v1h-1v1h-1v1H8v-1H7v-1H6v-2h1v-1h1v-1h1v-1h1V9H9V8H8V7h1V6h9v9h-1v1h-1v-1h-1v-1h-2v1z" />
  </svg>
);

export const Reddit = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M14 15h1v1h-1zM13 12h2v2h-2zM9 12h2v2H9zM9 15h1v1H9z" />
    <path d="M22 9V7h-1V5h-1V4h-1V3h-2V2h-2V1H9v1H7v1H5v1H4v1H3v2H2v2H1v6h1v2h1v2h1v1h1v1h2v1h2v1h6v-1h2v-1h2v-1h1v-1h1v-2h1v-2h1V9h-1Zm-3 5h-1v1h-1v2h-1v1h-2v1h-4v-1H8v-1H7v-3H6v-1H5v-2h1v-1h2v1h1v-1h3V5h2v1h3v2h-2V7h-2v3h2v1h1v-1h2v1h1v3Z" />
    <path d="M10 16h4v1h-4z" />
  </svg>
);

export const Golden = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M6 9h1v1H6z" />
    <path d="M23 9v6h-1v1h-1v2h-1v1h-1v1h-1v1h-2v1h-2v1h-4v-1H8v-1H6v-1H5v-1H4v-8h1v2h1v2h1v1h2v1h5v-1h2v-1h1v-1h1v-2h1v-1h1V5h1v2h1v2h1z" />
    <path d="M5 10h1v1H5zM16 11h1v1h-1z" />
    <path d="M4 10H3v7H2v-3H1V9h1V7h1V5h1V4h1V3h2V2h2V1h6v1h2v1h1v1h1v6h-1v1h-1V8h-2V7H7v1H5v1H4v1z" />
  </svg>
);

export const ProductHunt = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M15 9v2h-1v1h-4V8h4v1h1z" />
    <path d="M22 9V7h-1V5h-1V4h-1V3h-2V2h-2V1H9v1H7v1H5v1H4v1H3v2H2v2H1v6h1v2h1v2h1v1h1v1h2v1h2v1h6v-1h2v-1h2v-1h1v-1h1v-2h1v-2h1V9h-1Zm-6 4h-2v1h-4v4H8V6h6v1h2v1h1v4h-1v1Z" />
  </svg>
);

export const Bloomberg = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M22 2V1H2v1H1v20h1v1h20v-1h1V2h-1ZM7 5h7v1h1v1h1v4h-1v1h1v1h1v4h-1v1h-1v1H7V5Z" />
    <path d="M15 14v2h-1v1H9v-4h5v1h1zM14 8v2h-1v1H9V7h4v1h1z" />
  </svg>
);

export const Figma = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M18 3.5v-1h-1v-1H7v1H6v1H5v3h1v1h1v2H6v1H5v3h1v1h1v2H6v1H5v3h1v1h1v1h5v-1h1v-6h4v-1h1v-1h1v-3h-1v-1h-1v-2h1v-1h1v-3h-1Zm-7 18H8v-1H7v-3h1v-1h3v5Zm0-7H8v-1H7v-3h1v-1h3v5Zm0-7H8v-1H7v-3h1v-1h3v5Zm6 3v3h-1v1h-2v-1h-1v-3h1v-1h2v1h1Zm-1-4v1h-3v-5h3v1h1v3h-1Z" />
  </svg>
);

export const NewsBreak = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M23 2v4h-1v6h-1v5h-1v1h-2v1h-2v1h-2v1h-2v-1h-1v-2h-1v-2H9v-2H8v1H7v1H6v1H5v2H4v1H3v1H2v1H1v-3h1v-4h1v-4h1V7h1V6h2V5h2V4h2V3h2v2h1v2h1v2h1v2h2V9h1V7h1V5h1V3h1V2h1z" />
  </svg>
);

export const Npm = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M22 2V1H2v1H1v20h1v1h20v-1h1V2h-1ZM12 8v11H5V5h14v14h-3V8h-4Z" />
  </svg>
);

export const XSocial = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M15.5 10V9h1V8h1V7h1V6h1V5h1V4h1V3h1V2h-3v1h-1v1h-1v1h-1v1h-1v1h-1v1h-2V7h-1V6h-1V4h-1V3h-1V2h-7v1h1v1h1v1h1v2h1v1h1v2h1v1h1v2h1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h3v-1h1v-1h1v-1h1v-1h1v-1h1v-1h2v1h1v1h1v2h1v1h1v1h7v-1h-1v-1h-1v-1h-1v-2h-1v-1h-1v-2h-1v-1h-1v-2h-1v-1h1Zm0 4v1h1v2h1v1h1v2h-3v-2h-1v-1h-1v-1h-1v-2h-1v-1h-1v-1h-1v-2h-1V9h-1V7h-1V6h-1V4h3v1h1v2h1v1h1v2h1v1h1v1h1v2h1Z" />
  </svg>
);

export const FacebookRound = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M23 9v6h-1v2h-1v2h-1v1h-1v1h-2v1h-2v1h-1v-8h2v-1h1v-2h-3V9h1V8h2V5h-4v1h-2v2h-1v4H7v3h3v8H9v-1H7v-1H5v-1H4v-1H3v-2H2v-2H1V9h1V7h1V5h1V4h1V3h2V2h2V1h6v1h2v1h2v1h1v1h1v2h1v2h1z" />
  </svg>
);

export const Digg = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M8 5h2v2H8zM5 5v3H2v8h5V5H5Zm0 9H4v-4h1v4ZM8 8h2v8H8zM11 8v8h3v1h-3v2h5V8h-5Zm2 2h1v4h-1v-4ZM17 8v8h3v1h-3v2h5V8h-5Zm2 2h1v4h-1v-4Z" />
  </svg>
);

export const Podcast = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M9 14H8v-2h3v-1H8V9h3V8H8V6h3V5H8V3h1V2h1V1h4v1h1v1h1v2h-3v1h3v2h-3v1h3v2h-3v1h3v2h-1v1h-1v1h-4v-1H9v-1z" />
    <path d="M19 12v3h-1v2h-1v1h-2v1h-2v2h3v2H8v-2h3v-2H9v-1H7v-1H6v-2H5v-3h1v2h1v2h1v1h2v1h4v-1h2v-1h1v-2h1v-2h1z" />
  </svg>
);

export const Linkedin = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M22 2V1H2v1H1v20h1v1h20v-1h1V2h-1Zm-9 10v8h-3V9h3v1h1V9h4v1h1v10h-3v-8h-3ZM4 8V5h3v3H4Zm3 1v11H4V9h3Z" />
  </svg>
);

export const Youtube = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M22 7V5h-2V4H4v1H2v2H1v10h1v2h2v1h16v-1h2v-2h1V7h-1Zm-10 8h-2V9h2v1h2v1h2v2h-2v1h-2v1Z" />
  </svg>
);

export const Instagram = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M17 9V8h-1V7h-1V6H9v1H8v1H7v1H6v6h1v1h1v1h1v1h6v-1h1v-1h1v-1h1V9h-1Zm-1 5h-1v1h-1v1h-4v-1H9v-1H8v-4h1V9h1V8h4v1h1v1h1v4Z" />
    <path d="M22 5V3h-1V2h-2V1H5v1H3v1H2v2H1v14h1v2h1v1h2v1h14v-1h2v-1h1v-2h1V5h-1Zm-1 14h-1v1h-1v1H5v-1H4v-1H3V5h1V4h1V3h14v1h1v1h1v14Z" />
    <path d="M17 5h2v2h-2z" />
  </svg>
);

export const Rss = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M22 2V1H2v1H1v20h1v1h20v-1h1V2h-1Zm-6 16v-3h-1v-2h-1v-1h-1v-1h-1v-1h-1V9H9V8H7V7H4V4h3v1h2v1h2v1h2v1h1v1h1v1h1v1h1v2h1v2h1v2h1v3h-3v-2h-1Zm-5 0v-2h-1v-1H9v-1H8v-1H6v-1H4V9h2v1h2v1h2v1h1v1h1v1h1v2h1v2h1v2h-3v-2h-1Zm-7 1v-3h1v-1h3v1h1v3H8v1H5v-1H4Z" />
  </svg>
);

export const ViewBlock = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M21 11V9h-1V7h-1V6h-1V5h-1V4h-2V3h-2V1h-2v2H9v1H7v1H6v1H5v1H4v2H3v2H1v2h2v2h1v2h1v1h1v1h1v1h2v1h2v2h2v-2h2v-1h2v-1h1v-1h1v-1h1v-2h1v-2h2v-2h-2Zm-10 8h-1v-1H8v-1H7v-1H6v-1H5V9h1v1h1v1h1v1h2v1h1v6Zm-1-8v-1H8V9H7V8H6V7h2V6h2V5h4v1h2v1h2v1h-1v1h-1v1h-2v1h-4Zm9 4h-1v1h-1v1h-1v1h-2v1h-1v-6h1v-1h2v-1h1v-1h1V9h1v6Z" />
  </svg>
);
export const HuggingFace = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M20 17h1v1h-1zM19 18h1v1h-1zM18 17h1v1h-1zM19 16h1v1h-1zM20 15h1v1h-1zM19 14h1v1h-1zM18 15h1v1h-1zM17 16h1v1h-1zM17 14h1v1h-1zM16 15h1v1h-1z" />
    <path d="M19 19v1h-5v-3h1v-1h1v1h1v1h1v1h1zM22 15h1v5h-1zM21 8h1v7h-1zM20 20h2v1h-2zM20 6h1v2h-1zM19 5h1v1h-1zM18 4h1v1h-1zM16 3h2v1h-2zM14 21h6v1h-6zM10 20h4v1h-4zM8 2h8v1H8zM7 15h1v1H7zM6 3h2v1H6zM6 16h1v1H6zM6 14h1v1H6z" />
    <path d="M10 17v3H5v-1h1v-1h1v-1h1v-1h1v1h1z" />
    <path d="M5 17h1v1H5zM5 15h1v1H5zM5 4h1v1H5zM4 21h6v1H4zM4 18h1v1H4zM4 16h1v1H4zM4 14h1v1H4zM19 9V7h-1V6h-1V5h-2V4H9v1H7v1H6v1H5v2H4v4h3v1h1v1h1v1h1v1h1v2h2v-2h1v-1h1v-1h1v-1h1v-1h3V9h-1ZM7 10H6V9h1v1Zm1 0V8h2v1H9v1H8Zm7 3h-1v1h-1v-1h-2v1h-1v-1H9v-2h1v1h4v-1h1v2Zm1-3h-1V9h-1V8h2v2Zm2 0h-1V9h1v1ZM4 5h1v1H4zM2 20h2v1H2zM3 17h1v1H3zM3 15h1v1H3zM3 6h1v2H3zM2 8h1v7H2zM1 15h1v5H1z" />
  </svg>
);
export const CrunchBase = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M22 2V1H2v1H1v20h1v1h20v-1h1V2h-1ZM5 10h5v1h1v2H9v-1H6v3h3v-1h2v2h-1v1H5v-1H4v-5h1v-1Zm14 7h-4v-1h-1v1h-1V7h2v3h4v1h1v5h-1v1Z" />
    <path d="M15 12h3v3h-3z" />
  </svg>
);

// icons for avatar creation tab

export const OutfitIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" id="Outfit_Icon" data-name="Outfit Icon" viewBox="0 0 24 24" {...props}>
    <defs>
      <style>{".cls-1{stroke-width:0}"}</style>
    </defs>
    <path d="M18 12h1v9h-1v1H6v-1H5v-9h1v-1h1V2h2v2h1v1h4V4h1V2h2v9h1v1z" className="cls-1" />
    <path
      d="M23 7v3h-1v1h-1v1h-1v-1h-1v-1h-1V3h1v1h1v1h1v1h1v1h1zM5 11H4v1H3v-1H2v-1H1V7h1V6h1V5h1V4h1V3h1v7H5v1z"
      className="cls-1"
    />
  </svg>
);

export const AccessoriesIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" data-name="Accessories Icon" viewBox="0 0 24 24" {...props}>
    <path
      d="M1 9v1h1v3h1v2h1v1h5v-1h1v-1h1v-3h2v3h1v1h1v1h5v-1h1v-2h1v-3h1V9H1Zm5 6H5v-1H4v-2H3v-2h1v2h1v2h1v1Zm11 0h-1v-1h-1v-2h-1v-2h1v2h1v2h1v1Z"
      style={{
        strokeWidth: 0,
      }}
    />
  </svg>
);

export const BackgroundIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" data-name="BG Icon" viewBox="0 0 24 24" {...props}>
    <path
      d="M23 9v6h-1v2h-1v2h-1v1h-1v1h-2v1h-2v1H9v-1H7v-1H5v-1H4v-1H3v-2H2v-2H1V9h1V7h1V5h1V4h1V3h2V2h2V1h6v1h2v1h2v1h1v1h1v2h1v2h1z"
      style={{
        strokeWidth: 0,
      }}
    />
  </svg>
);

export const EyeIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" id="Eye_Icon" data-name="Eye Icon" viewBox="0 0 24 24" {...props}>
    <defs>
      <style>{".cls-1{stroke-width:0}"}</style>
    </defs>
    <path
      d="M22 5V3h-1V2h-1V1h-4v1h-1v1h-1v2h-1v13h1v2h1v1h1v1h4v-1h1v-1h1v-2h1V5h-1Zm0 12h-1v1h-2v-1h-1V6h1V5h2v1h1v11ZM10 5V3H9V2H8V1H4v1H3v1H2v2H1v13h1v2h1v1h1v1h4v-1h1v-1h1v-2h1V5h-1Zm0 12H9v1H7v-1H6V6h1V5h2v1h1v11Z"
      className="cls-1"
    />
  </svg>
);

export const BrowIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" data-name="Brow Icon" viewBox="0 0 24 24" {...props}>
    <path
      d="M22 13v1h-2v-1h-4v-1h-6v1H7v1H5v1H2v-1H1v-2h1v-1h3v-1h4V9h7v1h2v1h2v1h1v1h1z"
      style={{
        strokeWidth: 0,
      }}
    />
  </svg>
);

export const BodyIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" id="Body_Icon" data-name="Body Icon" viewBox="0 0 24 24" {...props}>
    <defs>
      <style>{".cls-1{stroke-width:0}"}</style>
    </defs>
    <path
      d="M9 11H8V3h1V2h1V1h5v1h1v1h1v8h-1v1h-1v1h-5v-1H9v-1zM21 19v4H4v-4h1v-2h1v-1h2v-1h2v-1h5v1h2v1h2v1h1v2h1z"
      className="cls-1"
    />
  </svg>
);

export const MouthIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" data-name="Mouth Icon" viewBox="0 0 24 24" {...props}>
    <path
      d="M21 7V5h-1V4h-1V3h-2V2h-2V1H9v1H7v1H5v1H4v1H3v2H2v9h1v2h1v2h1v1h1v1h2v1h8v-1h2v-1h1v-1h1v-2h1v-2h1V7h-1ZM4 8V7h1V5h2V4h2V3h6v1h2v1h2v2h1v1H4Zm16 9h-1v2h-1v1h-2v1H8v-1H7v-1H6v-3h1v-1h1v-1h3v4h2v-2h1v-1h1v-1h3v1h1v1h1v1Z"
      style={{
        strokeWidth: 0,
      }}
    />
  </svg>
);

export const HairIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" data-name="Hair Icon" viewBox="0 0 24 24" {...props}>
    <path
      d="M20 7v15h-1v1h-4v-3h1v-1h1v-1h1v-5h-2v-1h-2v-1h-1v-1h-1V9h-1V8H9v1H8v1H7v1H6v6h1v1h1v1h1v4H5v-1H4V7h1V5h1V4h1V3h1V2h2V1h4v1h2v1h1v1h1v1h1v2h1z"
      style={{
        strokeWidth: 0,
      }}
    />
  </svg>
);

export const BeardIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 67 copy 2" viewBox="0 0 24 24" {...props}>
    <path
      d="M21 12v1h-2v1h-1v1h-4v-1h-1v-1h-2v1h-1v1H6v-1H5v-1H3v-1h3v-1h2v-1h3v1h2v-1h3v1h2v1h3z"
      style={{
        strokeWidth: 0,
      }}
    />
  </svg>
);
